export default {
    vn: {
        dashboard: {
            employee: "Nhân viên",
            checkin: "Đã checkin",
            notCheckin: "Chưa checkin",
            late: "Đi muộn",
            employeeWorkEarly: "Nhân viên đi làm sớm nhất",
            empolyeeWorkLate: "Nhân viên đi làm muộn nhất",
            today: "hôm nay.",
            emty: "Trống",
            yesterday: "hôm qua.",
            times: 'Thời gian',
            times7day: "Thời gian checkin trong 7 ngày.",
            checkinEarly: "Checkin sớm",
            checkinLate: "Checkin muộn",
            leave: "Xin nghỉ",
            employeeLeave: "Nhân viên xin nghỉ",
            meeting: "Phòng họp",
            bookMeeting: "Lịch đặt phòng họp hôm nay.",
            event: "Sự kiện",
            allEvent: "Tất cả sự̣ kiện trong tháng.",
            noCheckin: "Không checkin",
            workEarly: "Đi sớm",
            workLate: "Đi muộn",
            errSumEmployee: "Có lỗi lấy tổng số nhân viên",
            errMs: "Có lỗi xảy ra !",
            errSumEmployeeCheckin:  "Có lỗi lấy tổng số nhân viên checkin.",
            errSumEmployeeLate: "Có lỗi lấy tổng số nhân viên đi muộn.",
            errSumEmployeeNotCheckin: "Có lỗi lấy tổng số nhân viên chưa checkin.",
            errSumEmployeeWorkEarly: "Có lỗi lấy tổng số nhân viên đến sớm.",
            errSumEmployeeWorkLate: "Có lỗi lấy tổng số nhân viên đi muộn.",
            errGetMeetingZoom: "Có lỗi lấy phòng họp",


        },
        managementConfiguration:{
            selectEmployee: 'Chọn nhân sự',
            selectManager:'Chọn quản lí',
            groupName:'Tên nhóm',
            update:'Cập nhật',
            addGroup:'Thêm mới nhóm',
            noData: 'Không có dữ liệu',
            noDataMatching: 'Không có kết quả',
        },
        heatmap: {
            title: 'Bản đồ nhiệt là công cụ giúp bạn phân tích lưu lượng truy cập bên trong cửa hàng bán lẻ của mình. Xác định các khu vực phổ biến và không phổ biến',
            feature_1: 'Tìm hiểu các mô hình chuyển động của khách hàng chính trong cửa hàng bán lẻ của bạn',
            feature_2: 'Tăng doanh số bán hàng trên kệ bằng cách đặt hàng hóa ở những khu vực phổ biến nhất',
            feature_3: 'Tối ưu hóa việc sắp xếp và phân loại trong các khu vực “lạnh”',
            feature_4: 'Lập kế hoạch vị trí đặt kệ và trưng bày để phân bổ đồng đều của khách',
            feature_5: 'Đánh giá hiệu quả của quảng cáo bằng cách so sánh “bản đồ nhiệt độ” trước và sau khi các chiến dịch tiếp thị bắt đầu',
            featurer_6: 'Lập kế hoạch số lượng nhân viên dựa trên khối lượng công việc của cửa hàng bán lẻ'
        },
        faceRecignition: {
            intro: 'Nhận diện gương mặt',
            title: 'Nhận diện gương mặt là một công cụ để nhận dạng gương mặt trong thời gian thực. Xác định khách hàng và nhân viên, phân tích dữ liệu về lượt truy cập và phân tích dữ liệu nhân khẩu học',
            feature_1: 'Theo dõi lưu lượng truy cập, nhân khẩu học và cảm xúc của khách hàng',
            feature_2: 'Tạo và nhận diện danh sách khách hàng VIP',
            feature_3: 'Chấm công nhân viên văn phòng',
            feature_4: 'Tìm người theo ảnh, tên, thời gian và địa điểm',
            feature_5: 'Một thuật toán nhận dạng mạnh mẽ. Nhận dạng ngay cả khi đeo khẩu trang',
            featurer_6: 'Nhận thông báo nhận diện nhanh chóng',
            setup: 'Cài đặt camera'
        },

        aiRestrictedarea:{
            intro: 'Phát hiện xâm nhập',
            title: 'Phát hiện xâm nhập là một công cụ để phát hiện xâm nhập theo thời gian thực',
            feature_1: 'Phát hiện xâm nhập nhanh chóng và chính xác nhờ AI',
            feature_2: 'Tạo vùng giám sát đa dạng, chính xác cao',
            feature_3: 'Tiết kiệm chi phí vận hành và lắp đặt',
            feature_4: 'Nhận thông báo cảnh báo xâm nhập tức thì',
            feature_5: 'Lưu trữ dữ liệu đối tượng xâm nhập',
            featurer_6: 'Giám sát an toàn nơi thiết lập cảnh báo xâm nhập',
            setup: 'Cài đặt camera'
        },
        fireAlarm: {
            intro: 'Cảnh Báo Cháy',
            title: 'Cảnh báo cháy công nghệ trí tuệ nhân tạo (AI) là một công cụ giúp bạn phát hiện các dấu hiệu cháy nổ một cách nhanh chóng nhất với độ chính xác cao kể cả trong môi trường nhiều trở ngại. Các khu vực được lắp đặt camera sẽ được bảo vệ an toàn mà không cần có sự hỗ trợ của các giải pháp khác.',
            feature_1: 'Phát hiện cháy nhanh ngay tại nguồn, giảm thiểu thiệt hại',
            feature_2: 'Thiết bị thông minh, công nghệ trí tuệ nhân tạo (AI)',
            feature_3: 'Tiết kiệm chi phí vận hành và lắp đặt',
            feature_4: 'Bảo vệ tính mạng và tài sản của con người',
            feature_5: 'Thông báo đẩy về Email và Điện Thoại nhanh chóng',
            featurer_6: 'Nhận dạng khói và lửa bằng AI'
        },
        minioStorage: {
            dateRange: 'Khoảng thời gian',
            totalFile: 'Tổng số File',
            totalFileError: 'Tổng số File lỗi',
            day: 'ngày',
            totalStorage: 'Tổng dung lượng',
            storage: 'Dung lượng'
        },
        getDocument: {
            textCopyData: 'Sao chép dữ liệu thành công !',
            intro: 'Giới thiệu',
            intro1: 'Thêm mới 1 camera',
            intro2: 'Cập nhật luồng liên kết',
            intro3: 'Cập nhật lưu trữ',
            intro4: 'Xóa camera',
            intro5: 'Ngừng kết nối camera',
            intro6: 'Kết nối camera',
            intro7: 'Danh sách tệp xem lại',
            intro8: 'Danh sách camera',
            intro9: 'Lịch sử đăng kí gói camera',
            intro10: 'Tạo mới tệp FTP',
            intro11: 'Tìm kiếm tệp FTP',
            intro12: 'Danh sách gói cước camera',
            intro13: 'Tạo mới ftp file + Tạo mới camera',
            example: 'Ví dụ',
            detail1: 'User thêm mới 1 camera.',
            detail2: 'User cập nhật link stream cho camera.',
            detail3: 'User cập nhật gói cước cho camera.',
            detail4: 'User xoá camera.',
            detail5: 'User ngừng kết nối stream camera.',
            detail6: 'User kết nối stream cho camera.',
            detail7: 'User lấy danh sách video lưu lại.',
            detail8: 'User lấy danh sách camera.',
            detail9: 'User lấy lịch sử đăng ký gói dịch vụ của camera.',
            detail10: 'User gửi ftp của camera tới hệ thống Inviv. Inviv kiểm tra user và camera hợp lệ sẽ ghi nhận vào hệ thống.',
            detail11: 'User gửi ftp và thông tin camera tới hệ thống Inviv. Inviv kiểm tra camera đã tồn tại trong hệ thống chưa, nếu chưa có sẽ tạo ra 1 camera tương ứng và ghi nhận dữ liệu ftp đã gửi.',
            detail12: 'User tìm kiếm các file ftp đã gửi trong hệ thống Inviv.',
            detail13: 'User tìm kiếm các gói cước cho camera.',
            translate1a: 'Định danh camera',
            translate1b: 'Tên camera',
            translate1c: 'Link rtsp camera',
            translate1d: 'Mã gói cước',
            translate1e: 'Thời gian bắt đầu muốn lấy dữ liệu, kiểu dữ liệu là milliseconds',
            translate1f: 'Thời gian kết thúc muốn lấy dữ liệu, kiểu dữ liệu là milliseconds',
            translate1g: 'Trang',
            translate1h: 'Số lượng bản ghi trong 1 trang',
            translate1l: 'Loại video xem lại "session"(mặc định) hoặc "event"',
            translate1m: 'Dung lượng file',
            translate1n: 'Tên file',
            translate1i: 'Đường dẫn tương đối',
            translate1k: 'Thời gian bắt đầu của video, kiểu dữ liệu ISOString("2022-11-30T07:39:00.000+0000")',
            translate1j: 'Thời gian kết thúc của video, kiểu dữ liệu ISOString("2022-11-30T07:39:00.000+0000")',
            translate1p: 'Thời gian bắt đầu tìm kiếm, kiểu dữ liệu ISOString("2022-11-30T07:39:00.000+0000") theo thời gian Inviv ghi nhận dữ liệu',
            translate1o: 'Thời gian kết thúc tìm kiếm, kiểu dữ liệu ISOString("2022-11-30T07:39:00.000+0000") theo thời gian Inviv ghi nhận dữ liệu',
            translate1q: 'Id bên phía Inviv',
            translate1w: 'Thời gian bắt đầu tìm kiếm, kiểu dữ liệu ISOString("2022-11-30T07:39:00.000+0000") theo thời gian Inviv ghi nhận dữ liệu',
            translate1r: 'Thời gian kết thúc tìm kiếm, kiểu dữ liệu ISOString("2022-11-30T07:39:00.000+0000") theo thời gian Inviv ghi nhận dữ liệu',
            note1a:'Video lưu trữ tự động.',
            note1b: 'Video lưu trữ theo sự kiện của người dùng.',
        },
        getHelpr: {
            analy: 'Nhóm phân tích',
            faceRecognition: 'Nhận dạng khuôn mặt',
            countingVisitors: 'Đếm số lượng khách truy cập',
            titleFaceRecognition: 'Trợ giúp › Nhận dạng khuôn mặt',
            titleCountingVisitors: 'Trợ giúp › Đếm số lượng khách truy cập',
            getDocument: 'Tài liệu API '
        },
        getHelpCountingVisitors: {
            line1: 'Không tìm thấy những gì bạn cần? Liên hệ với ',
            line2: 'bộ phận hỗ trợ kỹ thuật của chúng tôi',
            line3: 'Điều gì ảnh hưởng đến độ chính xác tính toán?',
            line4: 'Đám mây theo dõi chuyển động của chủ thể trong khung so với nền tĩnh, đếm số lần một đường định sẵn bị vượt qua. Để có kết quả tốt nhất, bạn cần các đối tượng có thể nhìn thấy rõ ràng là những thứ duy nhất chuyển động.',
            line5: 'Lựa chọn máy ảnh',
            line6: 'Độ phân giải',
            line7: 'Độ phân giải không thực sự đóng một vai trò quan trọng trong việc tính toán chính xác như thế nào. Khung hình được sử dụng cuối cùng được giảm xuống còn 160 × 90. Để hoạt động bình thường, bộ đếm cần có camera có độ phân giải',
            line8: ' ít nhất là 1,3 MP ',
            line9: 'Độ nhạy sáng',
            line10: 'Độ nhạy sáng bạn cần phụ thuộc vào mức độ ánh sáng của đối tượng. Chỉ cần đảm bảo rằng bạn không thấp hơn',
            line11: ' 0.1 lux',
            line12: '. Càng ít ánh sáng chiếu vào đối tượng của bạn, thì máy ảnh của bạn càng cần nhiều độ nhạy sáng hơn',
            line13: 'Vị trí Camera',
            line14: 'Vị trí và chiều cao',
            line15: 'Máy ảnh nên được treo ',
            line16: ' từ trần nhà',
            line17: '. Ống kính máy ảnh phải được nhắm',
            line18: ' vuông góc',
            line19: ' với mặt đất. Nếu bạn không thể treo nó từ trần nhà, bạn không sao nếu bạn tìm thấy một vị trí có góc nhỏ hơn một chút so với phương thẳng đứng. Góc không được vượt quá ',
            line20: '±25 độ',
            line21: 'Máy ảnh có thể ',
            line22: ' cách mặt đất từ ba đến sáu mét',
            line23: 'Chiếu sáng',
            line24: 'Bộ đếm sẽ nghĩ rằng bóng lớn (hoặc ánh sáng chói) là chủ thể. Để thuật toán hoạt động chính xác, máy ảnh phải được hướng vào khu vực có ',
            line25: 'ánh sáng đồng đều',
            line26: 'Ánh sáng kém hoặc quá mức có thể khiến đối tượng khó nhận ra so với hậu cảnh. Đối với mức ánh sáng tối thiểu trong khu vực bạn sẽ đếm chủ thể, hãy nhắm tới ',
            line27: ' 100 lux ',
            line28: '(sử dụng ứng dụng Lux Light Meter để có được số đọc gần đúng).',
            line29: 'Nếu khu vực này quá tối, bạn sẽ phải thiết lập các nguồn sáng bổ sung.',
            line30: 'Đối tượng không liên quan',
            line31: 'Khung phải không có  ',
            line32: 'chuyển động bên ngoài ',
            line33: ' (mở cửa, thang cuốn, v.v.) vì thuật toán có thể đếm bất kỳ đối tượng chuyển động nào về con số cuối cùng.',
            line34: 'Cài đặt camera',
            line35:'Tốc độ khung hình trên giây',
            line36: 'Bộ đếm có thể không bắt được các đối tượng chuyển động nhanh nếu tốc độ khung hình của máy ảnh quá thấp. Chúng tôi đề xuất tốc độ ',
            line37: 'ít nhất 20 khung hình / giây ',
            line38: 'Cài đặt bộ đếm',
            line39: 'Vạch ngang',
            line40: 'Để quầy hoạt động chính xác, bạn cần đặt một ',
            line41: 'dòng',
            line42: ' mà các đối tượng sẽ vượt qua để đăng ký. Đường thẳng không nhất thiết phải thẳng và có thể được vẽ theo bất kỳ cách nào bạn muốn',
            line43: 'Kích thước đối tượng trung bình',
            line44: 'Để tối đa hóa độ chính xác của bộ đếm, hãy đặt',
            line45: ' kích thước đối tượng trung bình',
            line46: ' cho khung. Giá trị phù hợp cho thông số này tùy thuộc vào ngữ cảnh cụ thể của bạn.',
            line47: 'Các khu vực loại trừ\n' +
                '\n',
            line48: 'Nếu có các khu vực trong khung có chuyển động mà bạn không muốn theo dõi, hãy tạo các ',
            line49: 'khu vực loại trừ',
            line50: ' trong cài đặt',
            line51: 'Chiều cao lắp đật',
            line52: 'Để tận dụng tối đa cài đặt bộ đếm của bạn, hãy đặt',
            line53: ' độ cao chính xác ',
            line54: ' mà bạn đã cài đặt bộ đếm \n' +
                '\n',
            line55: 'Xử lý sự cố',
            line56: 'Không đếm tất cả',
            line57: 'Phải làm gì:',
            line58: ' ● Đảm bảo rằng gói của bạn được thanh toán.',
            line59: ' ● Kiểm tra vị trí của máy ảnh, đặc biệt là độ cao của nó.',
            line60: ' ● Đo ánh sáng.',
            line61: ' ● Đặt vạch cắt ngang.',
            line62: ' ● Kiểm tra kích thước đối tượng trung bình.',
            line63: ' ● Xóa các khu vực loại trừ.',
            line64: 'Quá nhiều sự kiện',
            line65: 'Vấn đề',
            line66: 'Bộ đếm đang bị lỗi ở phía thấp',
            line67: 'Phải làm gì:',
            line68: ' ● Đảm bảo rằng không có bất kỳ đối tượng chuyển động thừa nào trong khung hình.',
            line69: ' ● Thêm các khu vực loại trừ.',
            line70: ' ● Kiểm tra ánh sáng (chói, bóng)',
            line71: ' ● Kiểm tra vị trí của máy ảnh, đặc biệt là độ cao của nó.',
            line72: ' ● kiểm tra kích thước trung bình',
            line73: ' ● Xóa các đường giao nhau thừa.',
            line74: 'Các kiểu kết nối',
                line75: 'Phương pháp 1: Qua đám mây ',
            line76: '\n' +
                'Bạn có thể kết nối bộ đếm khách truy cập với bất kỳ máy ảnh nào bạn có sẵn trong ứng dụng web',
            line77: 'Bộ đếm dựa trên đám mây dễ cài đặt và sử dụng hơn, được cập nhật thường xuyên và rẻ hơn các tùy chọn cạnh tranh.',
                line78: 'Phương pháp 2: Qua thiết bị',
            line79:'Sau khi bạn mua',
            line80:' \n' +
                'People Counter 3D, các kế hoạch riêng cho nó sẽ được cung cấp trong ứng dụng web.',
            line81: 'Các thiết bị Edge không yêu cầu kết nối internet và cung cấp các con số chính xác hơn, mặc dù chúng đắt hơn.',
            line82: 'Quá ít sự kiện',
            line83: 'Vấn đề',
            line84: 'Bộ đếm đang bị lỗi ở phía thấp',
            line85: 'Phải làm gì:',
            line86: ' ● Kiểm tra vị trí của máy ảnh, đặc biệt là độ cao của nó.',
            line87: ' ● Đo ánh sáng.',
            line88: ' ● Kiểm tra kích thước đối tượng trung bình.',
            line89: ' ● Xóa các khu vực loại trừ.',
            line90: ' ● Thêm đường giao nhau.',



        },
        getHelpFaceRecognition: {
            header: 'Phần Trợ giúp không giúp được gì? Liên hệ với ',
            headerContact: 'bộ phận hỗ trợ kỹ thuật của chúng tôi',


            tabs1: 'Điều gì ảnh hưởng đến chất lượng nhận dạng?',
            tabs1Info: 'Trong quá trình nhận dạng, đám mây so sánh khung hình đóng băng được kéo từ máy ảnh với ảnh của những người bạn đã tải lên. Cả hai bên phải có chất lượng cao và đáp ứng các yêu cầu của chúng tôi để có kết quả tốt nhất.',
            tabs1Detail1: 'Cố định khung hình từ máy ảnh',
            tabs1Detail1Info1: 'Độ phân giải hình ảnh đủ',
            tabs1Detail1Info11: 'Khuôn mặt trong ảnh phải có ít nhất',
            number200: ' 200 × 200 ',
            tabs1Detail1Info111: 'pixel. Độ phân giải thấp = ít thông tin về các điểm trên khuôn mặt = tỷ lệ lỗi cao trong quá trình so sánh.',
            tabs1Detail1Info2: 'Không bị mờ',
            tabs1Detail1Info22:'Hình ảnh phải rõ ràng',
            sharp: 'và sắc nét',
            tabs1Detail1Info222: '. Khi có nhiều vết mờ trong khung hình, sẽ có ít thông tin hữu ích hơn về khuôn mặt và do đó khả năng xảy ra lỗi cao hơn.',
            tabs1Detail1Info3: 'Chiếu sáng đầy đủ',
            tabs1Detail1Info33: 'Các khuôn mặt phải được',
            evenlylist: 'chiếu sáng đẩy đủ',
            tabs1Detail1Info333:', không bị bóng nặng hoặc chói. Những đốm đen hoặc bị trôi trên khuôn mặt có thể gây ra vấn đề khi thu thập thông tin về chúng.',
            tabs1Detaiil2: 'Hình ảnh của mọi người',
            threeAngles: 'Ba góc',
            youNeed: 'Bạn cần có ít nhất ba góc của những người bạn thêm vào danh sách của mình: ',
            facingForward: 'hướng về phía trước, hình bên trái và hình bên phải',
            thatWillHelp: '. Điều đó sẽ giúp hệ thống nhận dạng khuôn mặt từ nhiều góc độ khác nhau.',
            pictureQuality: 'Chất lượng hình ảnh',
            pictureQuality1: 'Hình ảnh khuôn mặt phải đáp ứng các yêu cầu chất lượng của chúng tôi: độ phân giải ít nhất ',
            pictureQuality2: '200 × 200 pixel',
            pictureQuality3: ', rõ ràng và không bị',
            pictureQuality4: ' mờ',
            pictureQuality5: ', ánh sáng đồng đều ',
            pictureQuality6: ' và không bị bóng hoặc lóa',


            tabs2: 'Mẹo về vị trí và cài đặt máy ảnh',

            tabs2s: 'Để đảm bảo bạn có được những khung hình cố định tốt nhất, hãy chú ý cẩn thận đến việc lựa chọn, vị trí và cấu hình máy ảnh của bạn.',

            tabs2D1: 'Lựa chọn máy ảnh',
            tabs2D1i1: 'Độ phân giải',
            tabs2D1i2: 'Độ phân giải bạn nên chọn tùy thuộc vào khoảng cách bạn sẽ cần để nhận dạng khuôn mặt. Cố gắng tuân theo tỷ lệ ',
            tabs2D1i3: '1 MP trên mét',
            tabs2D1i4: ' giữa máy ảnh và đối tượng.',
            tabs2D1i12: 'Độ nhạy sáng',
            tabs2D1i22: 'Độ nhạy sáng bạn cần phụ thuộc vào mức độ ánh sáng của đối tượng. Bất chấp điều đó, đừng thấp hơn',
            tabs2D1i32: ' 0.1 lux.',
            tabs2D1i42: ' Càng ít ánh sáng chiếu vào đối tượng của bạn, thì máy ảnh của bạn càng cần nhiều độ nhạy sáng hơn.',

            tabs2D2: 'Cài đặt camera',
            tabs2D2i1: 'Tốc độ khung hình',
            tabs2D2i2: 'Đừng vượt quá tốc độ khung hình',
            tabs2D2i3: '1/200',
            tabs2D2i4: ' . Nếu bạn làm vậy, hình ảnh của bạn sẽ bị mờ, dẫn đến vấn đề nhận dạng.',
            tabs2D2i12: 'Tốc độ bit',
            tabs2D2i22: 'Đảm bảo bạn luôn ở trên ',
            tabs2D2i32: ' 2 Mbps',
            tabs2D2i42: ' để không bị giảm chất lượng. Độ phân giải của bạn càng cao thì tốc độ bit càng nhanh.',

            tabs2D3: 'Vị trí đặt camera',
            tabs2D3i1: 'Khoảng cách',
            tabs2D3i2: 'Khoảng cách xa nhất bạn có thể đặt máy ảnh so với đối tượng của mình tùy thuộc vào độ phân giải của nó. Cố gắng tuân theo tỷ lệ ',
            tabs2D3i3: '1 MP per meter ',
            tabs2D3i4: 'giữa máy ảnh và đối tượng.',
            tabs2D3i12: 'Chiều cao',
            tabs2D3i22: 'Khuyến nghị của chúng tôi về độ cao để lắp đặt máy ảnh của bạn là nhắm đến',
            tabs2D3i32: ' 1.8 mét',
            tabs2D3i42: ' (chiều cao trung bình của con người). Nếu bạn không có bất cứ thứ gì xung quanh độ cao đó mà bạn có thể gắn nó vào, bạn có thể thả một thanh đặc biệt từ trần nhà xuống để treo ngay khoảng đó.',
            tabs2D3i13: 'Ánh sáng',
            tabs2D3i23: 'Bóng đè nặng (hoặc ánh sáng chói) trên khuôn mặt làm giảm lượng thông tin thị giác mà chúng ta có thể thu thập, khiến hệ thống dễ bị nhầm lẫn và dương tính giả. Đối với mức ánh sáng tối thiểu trong khu vực bạn sẽ nhận dạng khuôn mặt, hãy nhắm tới ',
            tabs2D3i33: '100 lux ',
            tabs2D3i43: ' (sử dụng ứng dụng Lux Light Meter để có số đọc gần đúng). Nếu khu vực này quá tối, bạn sẽ phải thiết lập các nguồn sáng bổ sung.',
            tabs2D3i14: 'Góc',
            tabs2D3i24: 'Khó nhận ra khuôn mặt từ bên cạnh, khi họ nhìn xuống hoặc từ bên dưới do không có đủ thông tin hình ảnh trong các khung hình cuối cùng (ví dụ: hồ sơ chỉ hiển thị một nửa khuôn mặt), vì vậy hãy đảm bảo bạn đã thiết lập máy ảnh của bạn hướng lên sao cho hầu hết các khuôn mặt sẽ đến ',
            tabs2D3i34: 'ngay với họ',

            tabs2D4: 'Cài đặt phát hiện',
            tabs2D4i1: 'Kích thước khuôn mặt tối thiểu',
            tabs2D4i2: 'Để đảm bảo khung hình cố định của bạn có đủ độ phân giải (ít nhất',
            tabs2D4i3: ' 200 × 200 pixel',
            tabs2D4i4: ' ), điều quan trọng là phải định cấu hình chính xác kích thước tối thiểu cho các khuôn mặt được phát hiện. Giá trị phù hợp cho thông số này tùy thuộc vào ngữ cảnh cụ thể của bạn.',
            tabs2D4i12: 'Khu vực phát hiện',
            tabs2D4i22: 'Nếu bạn có các khu vực trong khung mà bạn không cần phát hiện khuôn mặt (ví dụ: một quầy bán hàng khác), hãy đảm bảo bạn giới hạn',
            tabs2D4i32: ' khu vực phát hiện của mình trong cài đặt ',



            tabs3: 'Các vấn đề và giải pháp',

            tabs3D1: 'Rất nhiều lần phát hiện sai hoặc bị bỏ sót',
            tabs3D1i1: 'Phải làm gì:',
            tabs3D1i2: ' ● Cài đặt và cấu hình máy ảnh của bạn một cách chính xác.',
            tabs3D1i3: ' ● Tăng kích thước khuôn mặt tối thiểu.',

            tabs3D2: 'Không có phát hiện nào cả',
            tabs3D2i1: ' ● Đảm bảo rằng gói của bạn được thanh toán.',
            tabs3D2i2: ' ● Kiểm tra cài đặt phân tích trên máy chủ cục bộ của bạn',
            tabs3D2i3: ' ● Giảm ngưỡng chất lượng.',
            tabs3D2i4: ' ● Giảm kích thước khuôn mặt tối thiểu ',
            tabs3D2i5: ' ● Tăng khu vực phát hiện.',

            tabs3D3: 'Quá ít phát hiện',
            tabs3D3i1: 'Không phải tất cả các khuôn mặt trong khung đều được phát hiện.',
            tabs3D3i2: ' ● Giảm ngưỡng chất lượng.',
            tabs3D3i3: ' ● Giảm kích thước tối thiểu cho các khuôn mặt được phát hiện trong khung',
            tabs3D3i4: ' ● Tăng khu vực phát hiện.',

            tabs3D4: 'Phát hiện thừa',
            tabs3D4i1: '\n' +
                'Bạn đang nhận được những phát hiện mà bạn không quan tâm. Ví dụ, những người bên ngoài hoặc trong nền.',
            tabs3D4i2: ' ● Tăng kích thước tối thiểu cho các khuôn mặt được phát hiện trong khung',
            tabs3D4i3: ' ● Giảm khu vực phát hiện.',

            tabs3D5: 'Độ phân giải khung hình cố định không đủ',
            tabs3D5i1: 'Các khung hình cố định của bạn có chất lượng thấp do độ phân giải của chúng (dưới 200 × 200 pixel).',
            tabs3D5i2: ' ● Tăng kích thước tối thiểu cho các khuôn mặt được phát hiện trong khung',
            tabs3D5i3: ' ● Mua máy ảnh có độ phân giải cao hơn.',
            tabs3D5i4: ' ● Đến gần đối tượng của bạn hơn.',

            tabs3D6: 'Khung đóng băng mờ',
            tabs3D6i1: '\n' +
                'Khung hình đóng băng của bạn bị mờ và bất cứ thứ gì nhưng sắc nét.',
            tabs3D6i2: ' ● Giảm tốc độ cửa trập của máy ảnh.',
            tabs3D6i3: ' ● Thiết lập các nguồn sáng bổ sung trong khu vực.',
            tabs3D6i4: ' ● Mua máy ảnh có độ nhạy sáng cao hơn.',

            tabs3D7: 'Khung hình đóng băng tối (bóng nặng trên khuôn mặt).',
            tabs3D7i1: ' ● Tăng tốc độ chụp của máy ảnh.',
            tabs3D7i2: ' ● Thiết lập các nguồn sáng bổ sung trong khu vực.',
            tabs3D7i3: ' ● Mua máy ảnh có độ nhạy sáng cao hơn.',

            tabs3D8: 'Khung đóng băng được rửa sạch (ánh sáng chói trên khuôn mặt)',
            tabs3D8i1: ' ● Giảm tốc độ chụp của máy ảnh.',
            tabs3D8i2: ' ● Loại bỏ một số nguồn sáng trong khu vực.',
        },
        navMenu: {
            storageCamera: 'Dung lượng lưu trữ',
            manageOrgan: 'Quản lý tổ chức',
            organizationInformation: 'Thông tin tổ chức',
            branch: 'Chi nhánh',
            personnel: 'Nhân sự',
            servicePack: 'Gói dịch vụ',
            signUpService: 'Đăng ký gói dịch vụ',
            requestHistory: 'Lịch sử yêu cầu',
            customerManagement: 'KHÁCH HÀNG',
            customer: 'Khách hàng',
            historyInOut: 'Lịch sử ra vào',
            customerInOut: 'Khách hàng ra vào',
            cameraManage: 'Quản lý camera',
            stream: 'Xem trực tiếp',
            playBack: 'Xem lại',
            groupCamera: 'Nhóm camera',
            event: 'Sự kiện',
            intelligentHandling: 'AI - xử lí thông minh',
            intrusiveSettings: 'Cài đặt xâm nhập',
            infiltrationHistory: 'Lịch sử xâm nhập',
            faceRecognition: 'Nhận diện gương mặt',
            intrusionDetection: 'Phát hiện xâm nhập',
            faceRecognitionSetting: 'Cài đặt nhận diện gương mặt',
            listCameras: 'Danh sách camera',
            organization: 'Tổ chức',
            funcAuthority: 'Quyền chức năng AI',
            fireAlarm: 'Cài đặt báo cháy',
            heatMap: 'Bản đồ nhiệt',
            //Update
            leave: 'Đơn xin nghỉ',
            manageEmployee: 'NHÂN SỰ',
            resourceManagement: 'TÀI NGUYÊN',
            functionRoom: 'Phòng chức năng',
            manageCamera: 'Quản lý camera',
            checkIn: 'CHẤM CÔNG',
            wifiCheckIn: 'Wifi',
            qrCheckIn: 'Mã QR',
            shift: 'Ca làm việc',
            shiftDaybyday: 'Ca làm việc theo ngày',
            workMore: 'Làm tăng ca',
            historyCheckIn: 'Lịch sử chấm công',
            complaintLetter: 'Khiếu nại chấm công',
            manageNew: 'TRUYỀN THÔNG NỘI BỘ',
            mNew: 'Bảng tin',
            notification: 'Thông báo',
            manageDevice: 'TÀI SẢN',
            listDevice: 'Danh sách tài sản',
            historyDevice: 'Lịch sử tài sản',
            manageEquipment: 'VẬT DỤNG',
            listEquipment: 'Danh sách vật dụng',
            editEquipment: 'Cấp phát vật dụng',
            historyEquipment: 'Lịch sử vật dụng',
            leaveType: 'Loại nghỉ',
            leaveDate: 'Ngày nghỉ',
            comment: 'Bình luận',
            today: 'Hôm nay',
            before: 'Trước',
            after: 'Sau',
            nameMeeting: 'Tên phòng họp',
            location: 'Địa điểm',
            capacity: 'Số người',
            meetingDate: 'Ngày họp',
            meetingName: 'Tên cuộc họp',
            meeting: 'Phòng họp',
            purpose: 'Mục đích',
            startTime: 'Thời gian bắt đầu',
            endTime: 'Thời gian kết thúc',
            participants: 'Người tham dự',
            selectAttendees: 'Chọn người tham dự',
            leavePermission: 'Nghỉ có phép',
            unauthorizedAbsences: 'Nghỉ không phép',
            allDay: 'Cả ngày',
            byShift: 'Theo ca',
            activeStatus: 'Trạng thái hoạt động',
            policy: 'CHÍNH SÁCH',
            managePermision: 'Quản lý quyền hạn',
            managePosition: 'Quản lý chức vụ',
            externalDevice: 'Thiết bị ngoại vi',
            cardCustomer: 'Thẻ từ',
            department: 'Phòng ban',
            manageServiceType: 'Nhóm dịch vụ',
            manageServicePacks: 'Dịch vụ',
            servicePacks: 'DỊCH VỤ',
            care: 'CHĂM SÓC',
            incentives: 'Ưu đãi',
            manageIncentives: 'Ưu đãi, voucher',
            redemption: 'Đổi thưởng',
            feedback: 'Đánh giá, phản hồi',
            comboService: 'Gói dịch vụ',
            bookingSchedule: 'LỊCH HẸN',
            appointmentSchedule:'Lịch hẹn',
            bookingScheduleHistory: 'Lịch sử đặt lịch',
            newfeed: 'BẢNG TIN',
            newfeedMenuSub:'Bảng tin',
            postsWaitingForApproval: 'Bài viết chờ duyệt',
            postsApproved: 'Bài viết đã duyệt',
            postsRejected: 'Bài viết đã từ chối',
            restrictedKeywords: 'Từ khóa hạn chế',
            customerApp: 'Nguồn từ App',
            salesOffice1: 'Nguồn KD1',
            salesOffice2: 'Nguồn KD2',
            employeeSources: 'Nguồn nhân viên',
            otherSources: 'Nguồn khác',
            callCenter: 'TỔNG ĐÀI',
            overviewCallCenter: 'Tổng quan',
            consultingHistory: 'Lịch sử tư vấn',
            callHistory: 'Lịch sử cuộc gọi',
            monitorCallCenter: 'Giám sát',
            customerIdentification: 'Nhận diện khách hàng',
            waitingForReception: 'Khách hàng đặt lịch',
            receptionStep: 'Khách hàng tới phòng khám',
            consultingStep: 'Khách hàng tư vấn',
            feeCollectionStep: 'Khách hàng thu phí',
            paraclinicalExaminationStep: 'Khách hàng đang thực hiện',
            completedStep: 'Khách hàng hoàn thành',
            cardClass: 'Hạng thẻ',
            /*Care Module*/
            careDashboad: 'Thống kê chăm sóc',
            careSms: 'SMS chăm sóc',
            careEmail: 'Email chăm sóc',
            addNewsSms: 'Thêm SMS',
            smsBrandName: 'SMS Brand Name',
            smsMessenger: 'Tin nhắn',
            smsStatusDone: 'SMS đã chạy',
            smsStatus: 'SMS chưa chạy',
            /*End Care Module*/
            potentialCustomers:'Khách hàng tiềm năng',
            opportunisticCustomers:'Khách hàng cơ hội',
            managementConfiguration:'Cấu hình quản lý',
            bookingCustomers: 'Khách hàng đặt lịch',
            arriveCustomers: 'Khách hàng đến phòng khám',
            pancakeConfig: 'Cấu hình Pancake',
            medicalExamination: 'QUY TRÌNH',
            newEvent: 'TIN TỨC, SỰ KIỆN',
            settings: 'CÀI ĐẶT',
            generalCustomers: 'Khách hàng tổng hợp',
            callMonitoring:'Giám sát cuộc gọi',
            loginSession: 'Phiên đăng nhập',
            activeCall:'Cuộc gọi hoạt động'
        },
        notification: {
            pleaseEnter: 'Vui lòng nhập ',
            timelineNotification: 'thời gian nhận thông báo',
            years: ' năm',
            year: ' năm',
            day: ' ngày',
            days: ' ngày',
            hour: ' giờ',
            hrs: ' giờ',
            min: ' phút',
            mins: ' phút',
            secAgo: ' giây trước',
            justNow: 'Bây giờ',
            ago: ' trước'
        },
        inputTime: {
            today: 'Hôm nay',
            yesterday: 'Hôm qua',
            weekAgo: '1 tuần trước',
            monthAgo: '1 tháng trước',
            lastWeek: 'Tuần trước',
            lastMonth: 'Tháng trước',
            months3Ago: '3 tháng trước',
            months6Ago: '6 tháng trước',
            yearAgo: '1 năm trước'
        },

        login: {
            titleLogin: 'Quản lý camera tập trung trên nền tảng đám mây',
            rememberLogin: 'Ghi nhớ đăng nhập',
            logIn: 'Đăng nhập',
            noAcc: 'Bạn chưa có tài khoản đăng nhập ?',
            register: 'Đăng kí ngay',
            or: 'Hoặc',
            account: 'Tài khoản',
            password: 'Mật khẩu',
            infiltrationHistory: 'Lịch sử xâm nhập',
            intrusionDetection: 'Phát hiện xâm nhập',
            faceRecognition: 'Nhận diện gương mặt',
        },

        download: {
            textDownload: 'Tải app Inviv HRM',
            scan: 'QUÉT MÃ ĐỂ TẢI APP',
        },

        menuPackage: {
            historyPackageTitle: 'Lịch sử yêu cầu',
            signUpPackage: 'Đăng kí gói dịch vụ',
            experience: 'Đăng kí để trải nghiệm ngay dịch vụ.',
            package: 'Gói',
            packageHistory: 'của bạn sẽ hết hạn',
            packageHistoryDate: 'của bạn sẽ hết hạn vào ngày',
            renew: 'Để theo dõi dữ liệu mới, hãy gia hạn gói của bạn ngay bây giờ',
            limit: 'Giới hạn',
            storageTime: 'Thời gian lưu trữ',
            day: 'ngày',
            search: 'Tìm kiếm',
            storageCapacity: 'Dung lượng lưu trữ',
            totalCamera: 'Số camera',
            totalCameraAI: 'Số camera sử dụng AI',
            quality: 'Chất lượng',
            date: 'Ngày sử dụng',
            cost: 'Chi phí',
            functional: 'Chức năng AI',
            generalInformation: 'Thông tin chung',
            organizationName: 'Tên tổ chức',
            phoneNumber: 'Số điện thoại',
            password: 'Mật khẩu',
            rePassword: 'Nhập lại mật khẩu',
            city: 'Tỉnh/Thành phố',
            district: 'Quận/ Huyện',
            commune: 'Xã / Phường',
            houseNumber: 'Số nhà',
            address: 'Địa chỉ',
            already: 'Nếu bạn đã có tài khoản, hãy nhấp vào đây để',
            register: 'Đăng ký',
            infiltrationHistory: 'Lịch sử xâm nhập',
            intrusionDetection: 'Phát hiện xâm nhập',
            faceRecognition: 'Nhận diện gương mặt',
            packageName: 'Gói cước',
            endDate: 'Ngày hết hạn',
            storageDate: 'Ngày lưu trữ',
            useAI: 'Camera sử dụng AI',
            titlePackage: 'Lịch sử & trạng thái xử lý yêu cầu mở rộng, nâng cấp và gia hạn gói.',
            softwarePackage: 'Tên gói phần mềm',
            requestDate: 'Ngày yêu cầu',
            singUpPackage: 'Yêu cầu dịch vụ gói ',
            singUpSuccess: ' thành công',
            price: 'Giá',
            status: 'Trạng thái',
            actions: 'Hành động',
            null: 'Không xác định',
            shop: 'Cửa hàng',
            company: 'Công ty',
            education: 'Giáo dục',
            packageInactive: 'Chưa được kính hoạt',
            packageExpire: 'Hết hạn',
            packageDay: 'ngày',
            time: 'Thời gian (tháng)',
            amount: 'Đơn giá (vnđ)',
            paymentType: 'Loại thanh toán',
            modifiedDate: 'Ngày cập nhật',
            payment: 'Thanh toán',
            packageInformation: 'Thông tin gói cước',
            numberOfMonth: 'Số tháng',
            packagePolicy: 'Chính sách gói cước:',
            packagePolicy1: '- Mỗi gói cước được sử dụng tối đa trong vòng 1 tháng.',
            packagePolicy2: '- Gói cước không tự động gia hạn, có thể quản lý và huỷ gói cước bất cứ lúc nào.',
            packagePolicy3: '- Gói cước nâng cấp sau sẽ tự động được kích hoạt khi gói cước cũ hết hạn.',
            cameraInfo: 'Thông tin camera',
            cameraName: 'Tên camera',
            payInfo: 'Chi tiết thanh toán',
            durationPack: 'Thời hạn gói',
            totalPrice: 'Thành tiền',
            month: 'tháng',
            vnd: 'VNĐ',
            momoWallet: 'Ví MoMo',
            requestAdmin: 'Yêu cầu Admin xử lý',
            amountTrial: '** Số lần sử dụng gói Trial: ',
        },

        wifi: {
            addWifi: 'Thêm wifi',
            nameWifi: 'Tên wifi',
            status: 'Trạng thái',
            actions: 'Hành động',
            work: 'Hoạt động',
            notWork: 'Không hoạt động',
            branch: "Chi nhánh",
            sttWork: 'Trạng thái hoạt động'
        },

        qrCode: {
            addQr: 'Thêm QR Code',
            branch: 'Chi nhánh',
            qrEncoded: 'Chuỗi mã hóa QR',
            status: 'Trạng thái',
            actions: 'Hành động',
            sttWork: 'Trạng thái hoạt động',
            qrCode: 'Mã QR',
            exportF: 'Xuất File',
        },

        workShift: {
            restTime: 'Thời gian nghỉ giữa ca (phút)',
            branch: 'Chi nhánh',
            addWork: 'Thêm ca làm việc',
            group: 'Nhóm',
            shiftName: 'Tên ca',
            begin: 'Bắt đầu',
            finish: 'Kết thúc',
            flexibleTime: 'Thời gian linh động',
            actions: 'Hành động',
            branchName: 'Tên Chi Nhánh',
            setting: 'Cài đặt',
            groupName: 'Tên nhóm',
            workingDay: 'Ngày làm việc',
            startTime: 'Thời gian bắt đầu',
            endTime: 'Thời gian kết thúc',
            flexible: 'Linh động (Phút)',
            workThrough: 'Làm việc qua ngày',
            allowAdvance: 'Cho phép check in trước(phút)',
            allowInlater: 'Cho phép check in sau(phút)',
            allowCheckOutIn : 'Cho phép check out trước(phút)',
            allowCheckOutLater: 'Cho phép check out sau(phút)',
            endInNextDay: 'Làm việc qua ngày',
        },

        workShiftByDay: {
            branch: 'Chi Nhánh',
            employeeCode: 'Mã nhân viên',
            employeeName: 'Tên nhân viên',
            email: 'Email',
            phoneNumber: 'Số điện thoại',
            actions: 'Hành động',
            setting: 'Cài đặt',
            settingShiftByDay: 'Cài đặt ca làm việc qua ngày',
            name: 'Họ tên',
            addShift: 'Thêm ca làm việc',
            groupShift: 'Tên nhóm làm việc',
            nameShift: 'Tên ca làm việc',
            startTime: 'Thời gian bắt đầu',
            endTime: 'Thời gian kết thúc',
            flexible: 'Linh động (Phút)',
            workThrough: 'Làm việc qua ngày',
            allowAdvance: 'Chấp nhận check in trước(phút)',
            allowInlater: 'Chấp nhận check in sau(phút)',
            allowCheckOutIn : 'Chấp nhận check out trước(phút)',
            allowCheckOutLater: 'Chấp nhận check out sau(phút)',
            workDay: 'Ngày làm việc',
            settingAdvance: 'Cài đặt nâng cao',
            infoShift: "Thông tin ca làm việc",
            title: 'Tiêu đề',
            endInNextDay: 'Làm việc qua ngày',
        },

        overTime: {
            branch: 'Chi nhánh',
            employee: 'Nhân viên',
            status: 'Trạng thái',
            times: 'Thời gian',
            fitel: 'Lọc',
            createWork: 'Tạo ca làm thêm',
            employeeCode: 'Mã nhân viên',
            employeeName: 'Tên nhân viên',
            branchName: 'Tên chi nhánh',
            createDate: 'Ngày tạo',
            actions: 'Hành động',
            reseon: 'Lý do',
            beginDate: 'Ngày bắt đầu ca',
            startTime: 'Thời gian bắt đầu',
            endTime: 'Thời gian kết thúc',
            endDayWork: 'Ngày kết thúc ca',
            approved: 'Đã duyệt',
            wait: 'Chờ'
        },

        menuOrganization: {
            keySetting: 'Cài đặt tài khoản',
            organization: 'Tổ chức',
            organizationName: 'Tên tổ chức',
            acronym: 'Tên viết tắt',
            phoneNumber: 'Số điện thoại',
            organizationType: 'Loại tổ chức',
            expiredDate: 'Thời gian hết hạn',
            city: 'Tỉnh/Thành phố',
            district: 'Quận/ Huyện',
            commune: 'Xã / Phường',
            houseNumber: 'Số nhà, tên đường',
            streetName: 'Tòa nhà, Tên đường',
            address: 'Địa chỉ',
            activeStatus: 'Trạng thái hoạt động',
            addBranch: 'Thêm chi nhánh',
            branchName: 'Tên chi nhánh',
            branchType: 'Loại chi nhánh',
            branch: 'Chi nhánh',
            employeeCode: 'Mã nhân viên',
            employeeName: 'Tên nhân viên',
            displayLeaveDate: 'Thời gian nghỉ',
            displayLeaveTime: 'Giờ nghỉ',
            approveEmployeeFullName: 'Người duyệt',
            status: 'Trạng thái',
            personalInformation: 'Thông tin cá nhân',
            createDepartment: 'Thêm mới phòng ban',
            department: 'Phòng ban',
            lastName: 'Họ',
            firstName: 'Tên',
            birthday: 'Ngày sinh',
            gender: 'Giới tính',
            location: 'Vị trí',
            employeeType: 'Loại nhân viên',
            salary: 'Lương',
            faceData: 'Dữ liệu khuôn mặt (10 ảnh)',
            workingTime: 'Thời gian làm việc',
            autoGenerate: 'Tự động tạo ca làm việc',
            group: 'Nhóm',
            shift: 'Ca',
            working: 'Đang làm việc',
            Manager: 'Trưởng phòng',
            authority: 'Quyền hạn',
            rePass: 'Đổi mật khẩu',
            newPass: 'Mật khẩu mới',
            addFace: 'Thêm dữ liệu khuôn mặt.',
            all: 'Tất cả',
            null: 'Chưa xác định',
            principalOffice: 'Trụ sở chính',
            userName: 'Tên đăng nhập',
            dataUpdate: 'Cập nhật dữ liệu thành công',
            noBranch: 'Hiện tại không tồn tại chi nhánh nào',
            validUsername: 'Tên đăng nhập hợp lệ',
            userExists: 'Tên đăng nhập đã tồn tại',
            cannotName: 'Tên phòng ban không được để trống.',
            theFuture: 'Ngày sinh không được ở tương lai.',
            geolocation: 'Vị trí địa lý chưa được chọn',
            succPersonnel: 'nhân sự thành công',
            oldData: 'Dữ liệu cũ sẽ bị ghi đè. Bạn có muốn ghi đè lên?',
            noOption:'Không tìm thấy kết quả phù hợp',
            email: 'Email',
            emptyList: 'Danh sách trống',
            locationMap: 'Vị trí',
            enterAddress: 'Nhập địa chỉ',
            updateOrganizationSS: 'Cập nhật tổ chức thành công',
            usernameAvailable: 'Tên đăng nhập đã tồn tại',
            pleaseSelectBranch: 'Vui lòng chọn "Chi nhánh" trước khi thêm nhân sự !',
            cameraEmpty: "Tất cả camera",

            startWork: 'Ngày bắt đầu làm việc',
        },
        menuNewsEvent:{
            stt: 'STT',
            img: 'Hình ảnh',
            description:'Mô tả',
            addNewsEvent: 'Thêm tin tức, sự kiện',
            search: 'Tìm kiếm',
            noRowsToShow: 'Không có dữ liệu',
            title:'Tiêu đề nội dung',
            emptyList: 'Danh sách trống',
            enterTitle:'Nhập tiêu đề',
            contentPost: 'Nội dung bài viết',
            textContextPost: 'Nhập nội dung bài viết...',
            nameTitle:'Tiêu đề',
            addNewEventNotify: 'Thêm tin tức, sự kiện thành công',
            updateNewEventNotify: 'Cập nhật tin tức, sự kiện thành công',
            type:'Chủ đề bài viết',
            news: 'Tin tức',
            event:'Sự kiện',
            noContentPost:'Chưa có tên chủ đề',
            searchTitle:'Nhập nội dung tìm kiếm...',
            active: "Trạng thái",
            activePost: "Trạng thái bài viết",
            action:"Hoạt động",
            noAction:"Không hoạt động",
            turnOnActive:"Mở trạng thái hoạt động",
            turnOffActive:"Đóng trạng thái hoạt động",
            onOff:"Tắt / Bật",
            createdDate:"Ngày tạo",

        },
        menuSMS:{
            stt: 'STT',
            sendTo: 'Gửi tới',
            smsBrandName: 'SMS Brand Name',
            typeSms: 'Loại tin nhắn',
            status: 'Trạng thái',
            description:'Mô tả',
            addNewsEvent: 'Thêm tin tức, sự kiện',
            search: 'Tìm kiếm',
            noRowsToShow: 'Không có dữ liệu',
            title:'Tiêu đề nội dung',
            emptyList: 'Danh sách trống',
            enterTitle:'Nhập tiêu đề',
            contentPost: 'Nội dung bài viết',
            textContextPost: 'Nhập nội dung bài viết...',
            nameTitle:'Tiêu đề',
            addNewEventNotify: 'Thêm tin tức, sự kiện thành công',
            updateNewEventNotify: 'Cập nhật tin tức, sự kiện thành công',
            type:'Chủ đề bài viết',
            news: 'Tin tức',
            event:'Sự kiện',
            noContentPost:'Chưa có tên chủ đề',
            searchTitle:'Nhập nội dung tìm kiếm...',
            active: "Trạng thái",
            activePost: "Trạng thái bài viết",
            action:"Hoạt động",
            noAction:"Không hoạt động",
            turnOnActive:"Mở trạng thái hoạt động",
            turnOffActive:"Đóng trạng thái hoạt động",
            onOff:"Tắt / Bật",
            createdDate:"Ngày tạo",

        },
        menuNewFeed: {
            search: 'Tìm kiếm',
            create: "Tạo mới",
            stt: "STT",
            user: "Tên người dùng",
            posts: "Bài viết",
            createdDate: "Ngày tạo",
            modifiedDate: "Ngày sửa",
            approvedDate: "Ngày duyệt",
            status: "Trạng thái",
            actions: "Hành động",
            wait: "Chờ duyệt",
            done: "Đã duyệt",
            reject: "Từ chối",
            interactionCount: "Lượt thích",
            commentCount: "Lượt bình luận",
            restrictedKeywords: "Từ khóa hạn chế",
            addKeyword: 'Thêm từ khóa hạn chế thành công',
            updateKeyword: 'Cập nhật từ khóa hạn chế thành công',
            type: 'Loại bài viết',
        },

        menuCustomer: {
            addCustomer: 'Thêm khách hàng',
            sourceCustomer: 'Nguồn khách hàng',
            customerCode: 'Mã khách hàng',
            branch: 'Chi nhánh',
            sourceType: 'Nguồn khách hàng',
            customerName: 'Tên KH',
            phoneNumber: 'Số điện thoại',
            dateCreated: 'Ngày tạo',
            customerInfo: 'Thông tin khách hàng',
            city: 'Tỉnh/Thành phố',
            district: 'Quận/ Huyện',
            commune: 'Xã/ Phường',
            houseNumber: 'Số nhà',
            address: 'Địa chỉ',
            faceData: 'Dữ liệu khuôn mặt',
            identityCard: 'CMT/CCCD',
            all: 'Tất cả',
            undefined: 'Chưa xác định',
            customer: 'Khách hàng',
            time: 'Thời gian',
            noRowsToShow: 'Không có dữ liệu',
            img: 'Hình ảnh',
            timeOfRecord: 'Thời điểm ghi nhận',
            addCustomerSS: 'Thêm khách hàng thành công',
            updateCustomerSS: 'Cập nhật khách hàng thành công',
            cardNumber: 'Mã thẻ',
            contactInfo: 'Thông tin khách hàng',
            type: 'Loại KH',
            organization: 'Đơn vị',
            actions: 'Hành động',
            addEmployee: 'Thêm nhân viên',
            dayOfBirth: 'Ngày sinh',
            age: 'Tuổi',
            weight: 'Cân nặng',
            gender: 'Giới tính',
            email: 'Email',
            ethnic: 'Dân tộc',
            career: 'Nghề nghiệp',
            stt: 'STT',
            job: 'Nghề nghiệp',
            status: 'Trạng thái tiếp nhận',
            employee: 'Nhân viên tư vấn',
            nanoCode: 'Mã KH',
            birthday: 'Ngày sinh',
            nickName: 'Tên FB/Zalo',
            partnerType: 'Đối tác',
        },

        userInviv: {
            stt: 'STT',
            customerName: 'Tên KH',
            phoneNumber: 'Số điện thoại',
            customerCode: 'Mã KH',
            type: 'Loại khách hàng',
            card: 'Số thẻ',
            points: 'Điểm thưởng',
            action: 'Hoạt động',
        },
        userHis: {
            stt: 'STT',
            customerName: 'Tên KH',
            customerCode: 'Mã KH',
            status: 'Trạng thái tiếp nhận',
            customerStatus: 'Trạng thái KH',
            consultants: 'Người tư vấn',
            consultantDate: 'Ngày tư vấn',
            action: 'Hoạt động',
        },

        message: {
            error: "Lỗi",
            success: "Thành công",
        },

        warningMenuCustomer: {
            titleReset: 'Xác nhận đặt lại mật khẩu',
            titleWarning: 'Xác nhận xóa',
            textDeleteCustomer: 'Bạn có chắc muốn xóa khách hàng ',
            acceptText: "Xoá",
            cancelText: "Huỷ",
            deleteSuccess: 'Xóa khách hàng thành công',
        },

        genderOption: {
            unknown: 'Khác',
            male: 'Nam',
            female: 'Nữ'
        },

        employeeTypeOptions: {
            unknown: 'Không xác định',
            trainee: 'Thử việc',
            officialStaff: 'Chính thức',
        },

        statusActive: {
            agree: 'Đang sử dụng',
            waiting: 'Đang chờ',
            decline: 'Từ chối',
            cancel: 'Hủy bỏ',
            systemProcessing: 'Hệ thống đang xử lý',
            error: 'Hệ thống bị lỗi',
            approve: 'Phê duyệt',
            approveNow: 'Phê duyệt ngay lập tức',
            waitingApprove: 'Đang chờ xử lý',
            waitingUpgrade: 'Đang chờ nâng cấp',
            abort: 'Hủy sử dụng',
            expries: 'Hết hạn',
            failure: 'Thất bại',
            approved: 'Đã duyệt',
            canceled: 'Đã hủy',
        },

        employeeStatus: {
            working: 'Đang làm việc',
            offWork: 'Đã nghỉ việc'
        },

        employeeScreen: {
            branch: 'Chi nhánh',
            department: 'Phòng ban',
            employeeId: 'Mã nhân viên',
            firstName: 'Họ',
            lastName: 'Tên',
            requiredEmployeeId: 'Mã nhân viên không được bỏ trống',
            requiredFirstName: 'Họ không được bỏ trống',
            requiredLastName: 'Tên không được bỏ trống',
            requiredUsername: 'Tên đăng nhập không được bỏ trống',
            requiredBirth: 'Ngày sinh không được bỏ trống',
            requiredEmail: 'Email không được bỏ trống',
            requiredStreet: 'Số nhà không được bỏ trống',
            requiredImage: 'Nhân viên cần ít nhất một ảnh nhận diện khuôn mặt',
        },

        root: {
            organizationName: 'Tên tổ chức',
            organizationType: 'Loại tổ chức',
            phoneNumber: 'Số điện thoại',
            status: 'Trạng thái',
            actions: 'Hành động',
            titleWarning: 'Xác nhận xóa',
            deleteOrgan: 'Bạn có chắc là muốn xóa tổ chức',
            deleteSuccess: 'Xoá tổ chức thành công',
            stopWorking: 'Ngừng hoạt động',
            active: 'Đang hoạt động',
            shop: 'Cửa hàng',
            company: 'Công ty',
            education: 'Giáo dục',
            organizationAcronym: 'Tên viết tắt',
            fullAddress: 'Địa chỉ',
            houseNumber: 'Toà nhà, Tên đường',
            street: 'Đường',
            expiredDate: 'Thời gian hết hạn',
            city: 'Tỉnh/Thành phố',
            district: 'Quận/Huyện',
            commune: 'Xã/Phường',
            address: 'Địa chỉ',
            partner: 'Đối tác',
            activeStatus: 'Trạng thái hoạt động',
            all: 'Tất cả',
            null: 'Chưa xác định',
            successOrganization: 'tổ chức thành công',
            noRowsToShow: 'Không có dữ liệu',
            cameraName: 'Tên camera',
            stream: 'Trực tuyến',
            storage: 'Lưu trữ',
            allOrgan: 'Tất cả tổ chức',
            yes: 'Có',
            no: 'Không',
            organization: 'Tổ chức',
            cameraBrand: 'Hãng camera',
            streamFormat: 'Định dạng stream',
            cameraSuccess: 'camera thành công',
            addFunc: 'Thêm chức năng',
            functionName: 'Tên chức năng',
            limitFunction: 'Bạn có chắc là muốn xoá chức năng giới hạn',
            removeFunction: 'Xóa chức năng giới hạn thành công',
            displayName: 'Tên hiển thị',
            functionalSuccess: "chức năng giới hạn thành công",
            addPack: 'Thêm gói dịch vụ',
            deletePack: 'Bạn có chắc là muốn xoá gói phần mềm',
            deletePackSucc: 'Xoá gói phần mềm thành công',
            packageName: 'Tên gói phần mềm',
            totalCamera: 'Số camera',
            price: 'Giá',
            priceVND: 'Giá(VND)',
            date: 'Ngày sử dụng',
            softwarePackage: 'Tên gói phần mềm',
            storageTime: 'Thời gian lưu trữ',
            totalCameraAI: 'Số camera sử dụng AI',
            storedData: 'Data lưu trữ',
            storeData: 'Data lưu trữ(GB)',
            resolution: 'Độ phân giải',
            packageTerm: 'Thời hạn gói',
            usingAI: 'Sử dụng chức năng AI',
            selectFunction: 'Chọn chức năng',
            day: 'ngày',
            successfulSoftware: 'gói phần mềm thành công',
            titlePackage: 'Lịch sử & trạng thái xử lý yêu cầu mở rộng, nâng cấp và gia hạn gói.',
            requestDate: 'Ngày yêu cầu',
            requestConsent: 'Xác nhận yêu cầu đồng ý',
            acceptPack: 'Bạn có chắc chắn muốn chấp nhận yêu cầu nâng cấp gói không',
            fewMinutes: 'Duyệt gói dịch vụ thành công',
            cancellation: 'Xác nhận yêu cầu hủy bỏ.',
            request:'Bạn có chắc chắn muốn hủy yêu cầu nâng cấp gói không',
            refused:'Từ chối nâng cấp gói thành công.',
            create: 'Tạo ',
            update: 'Cập nhật',
            cameraAlias: 'Định danh camera',
        },

        button: {
            settingAccount: 'Cài đặt tài khoản',
            loadMore: 'Xem thêm',
            onMapEdit: 'Chỉnh sửa bản đồ',
            request: 'Yêu cầu',
            cancel: 'Hủy bỏ',
            update: 'Cập nhật',
            create: 'Tạo mới',
            actions: 'Hành động',
            employee: 'Nhân viên',
            edit: 'Chỉnh sửa',
            delete: 'Xóa',
            back: 'Quay lại',
            updateAI: 'Cập nhật dữ liệu AI',
            addEmployee: 'Thêm nhân sự',
            addNew: 'Thêm mới',
            add: 'Thêm',
            save: 'Lưu',
            agree: 'Đồng ý',
            abort: 'Huỷ sử dụng',
            notNow: 'Không phải bây giờ',
            filter: 'Tìm kiếm',
            reload: 'Tải lại',
            addCamera: 'Thêm Camera',
            preview: 'Xem trước',
            close: 'Đóng',
            titleDelete: 'Xác nhận xoá',
            titleRessetAc: 'Bạn có chắc là sẽ đặt lại mật khẩu không ?',
            check: 'Kiểm tra',
            addOrganization: 'Thêm tổ chức',
            null: 'Chưa xác định',
            settingsOrganization: 'Cài đặt thông báo tổ chức',
            search: 'Tìm kiếm ...',
            addMeetingRoom: 'Thêm phòng họp',
            scheduleMeeting: 'Đặt lịch họp',
            payment: 'Mua gói',
            outOf: 'Hết lượt',
            updatePackage: 'Nâng cấp',
            off_on: 'Tắt/Bật',
            historyInOut: 'Lịch sử ra vào',
            addCard: 'Thêm thẻ',
            confirm: 'Xác nhận',
            complete: 'Hoàn thành',
            details: 'Chi tiết',
            phone: 'Gọi điện',
            approved: 'Duyệt',
            rejected: 'Từ chối',
            call: 'Gọi',
            /*SMS*/
            runSms: 'Gửi tin nhắn',
            detailSms: 'Xem chi tiết SMS',
            stopSms: 'SMS đã được chạy',
            message: 'Nhắn tin',
            remainer: 'Nhắc lịch',
        },

        warningMenuOrganization: {
            titleWarning: 'Xác nhận xóa',
            textWarning: 'Bạn có chắc muốn xóa nhân viên',
            textBranchWarning: 'Bạn có chắc muốn xóa chi nhánh',
            textBranch: 'không?',
            acceptText: "Xoá",
            cancelText: "Huỷ",
            textDeleteSuccess: 'Xóa chi nhánh thành công',
            deleteSuccess: 'Xóa thành công',
            textSuccess: 'Thay đổi mật khẩu thành công',
            textBranchSuccess: 'chi nhánh thành công',
            anErr: 'Đã có lỗi xảy ra',
            newDepartments: 'Thêm mới phòng ban',
            success: 'thành công.',
            emptyEmployee: 'Danh sách nhân viên trống',

        },

        textErr: {
            account: 'Tài khoản',
            password: 'Mật khẩu',
            organizationName: 'Tên tổ chức',
            organizationAcronym: 'Tên viết tắt',
            fullAddress: 'Địa chỉ',
            houseNumber: 'Toà nhà, Tên đường',
            street: 'Đường',
            zipCode: 'Zip Code',
            adminAccount: 'Tài khoản admin',
            phoneNumber: 'Số điện thoại',
            organizationType: 'Loại tổ chức',
            expiredDate: 'Thời gian hết hạn',
            organizationBranchName: 'Tên chi nhánh',
            cameraName: 'Tên camera',
            streamUrl: 'Link stream',
            employeeCode: 'Mã nhân viên',
            firstName: 'Họ',
            lastName: 'Tên',
            birthday: 'Ngày sinh',
            type: 'Tên tài sản',
            deviceType: 'Loại tài sản',
            brand: 'Hãng',
            model: 'Mã',
            serialNumber: 'Số Serial',
            totalQuantity: 'Số lượng',
            importDate: 'Ngày nhập',
            supplier: 'Nhà cung cấp',
            fromDate: 'Ngày bắt đầu',
            toDate: 'Ngày kết thúc',
            assignDate: 'Ngày cấp',
            reason: 'Lí do',
            workShiftName: 'Tên ca',
            workDayOfWeek: 'Ngày làm việc',
            startHour: 'Thời gian bắt đầu',
            endHour: 'Thời gian kết thúc',
            bufferTime: 'Thời gian linh động',
            groupName: 'Tên nhóm',
            allowCheckInBefore: 'Cho phép check in trước',
            allowCheckInAfter: 'Cho phép check in sau',
            allowCheckOutBefore: 'Cho phép check out trước',
            allowCheckOutAfter: 'Cho phép check out sau',
            equipmentType: 'Tên vật dụng',
            dailyWorkName: 'Tên công việc',
            startDate: 'Ngày bắt đầu',
            endDate: 'Ngày kết thúc',
            dailyWorkDetailName: "Tên vật dụng",
            methodCheck: "Phương pháp",
            completionCriteria: "Yêu cầu công việc",
            placeDetailName: "Tên địa điểm",
            level: "Cấp độ ưu tiên",
            address: "Địa chỉ",
            areaDetailName: "Tên khu vực",
            nameRestrictedarea: "Tên sự kiện",
            fromHour: "Thời gian bắt đầu",
            toHour: "Thời gian kết thúc",
            date: "Ngày khiếu nại chấm công",
            newPassword: "Mật khẩu mới",
            cameraGroupName: "Tên nhóm",
            qrCode: "Mã QR",
            titleNotify: "Nhập tiêu đề",
            abbreviate: "Nhập tóm tắt",
            name: "Tên phòng họp",
            location: 'Địa điểm',
            reservationName: "Tên cuộc họp",
            purpose: "Mục đích",
            dateBegin: "Ngày họp",
            meetingRoom: "Phòng họp",
            participants: 'Người tham dự',
            timeKeepingType: 'Đối tác',
            oldPassWord: 'Mật khẩu cũ',
            newPassWord: 'Mật khẩu mới',
            reNewPassWord: 'Nhập lại mật khẩu mới',
            title: 'Tiêu đề',
            email: 'Email',
            rePassword: 'Mật khẩu xác nhận',
            fullName: 'Tên đầy đủ',
            salary: 'Lương',
            manageMeeting: 'Quản lý phòng họp',
            bookAMeeting: 'Lịch họp',
            modifiedDate: 'Ngày cập nhật',
            time: 'Thời gian'
        },

        timeKeeping: {
            branch: 'Chi Nhánh',
            employee: 'Nhân viên',
            alreadyCheckin: 'Đã check in',
            late: 'Đi muộn',
            times: 'Thời gian:',
            filter: 'Lọc',
            createReport: 'Tạo báo cáo',
            employeeCode: 'Mã nhân viên',
            fullName: 'Họ tên',
            comeBackSoon: 'Về sớm',
            leaveWork: 'Nghỉ làm',
            typeCheckin: 'Loại chấm công',
            actions: 'Hành động',
            afterWork: 'Tan ca',
            onShift: 'Vào ca',
            date: 'Ngày',
            shift: 'Ca',
            detailCheck: 'Chi tiết chấm công',
            approve: 'Xác nhận chấm công',
            historyExport: 'Lịch sử tạo báo cáo'
        },

        updateInout: {
            branch: 'Chi Nhánh',
            employee: 'Nhân viên',
            status: 'Trạng thái',
            time: 'Thời gian',
            filter: 'Lọc',
            create: 'Tạo đơn',
            createReport: 'Tạo báo cáo',
            employeeCode: 'Mã nhân viên',
            employeeName: 'Tên nhân viên',
            date: 'Ngày',
            shift: 'Ca',
            timeInOut: 'Giờ ra vào',
            reason: 'Lý do',
            actions: 'Hành động',
            employeeStaff: 'Nhân sự',
            dateTimekeeping: 'Ngày khiếu nại chấm công',
            shiftWork: 'Ca làm việc',
            timeStart: 'Thời gian bắt đầu',
            timeEnd: 'Thời gian kết thúc',
            humanCom: 'Người duyệt bình luận',
            choseCamera: 'Chọn Camera',
            image: 'Hình ảnh',
            preTime: 'Thời điểm',
            export: 'Xuất báo cáo',
        },

        news: {
            addNews: 'Thêm bài viết',
            humanCreate: 'Người tạo',
            department: 'Bộ phận',
            departmentB: 'Phòng ban',
            title: 'Tiêu đề',
            content: 'Nội dung',
            actions: 'Hành động',
            typePost: 'Loại bài viết',
            roleView: 'Phân quyền xem',
            titlePost: 'Tiêu đề bài viết',
            contentPost: 'Nội dung bài viết',
            moreSelect: 'Nhiều lựa chọn',
            addSelect: 'Thêm lựa chọn',
            humanSelect: 'Người chọn',
            selection: 'Lựa chọn',
            enterTile: 'Nhập tiêu đề',
            selectDepartment: 'Chọn phòng ban',
            evaluate: 'Đánh giá',
            news: 'Bài viết',
            poll: 'Thăm dò ý kiến',
            departmentLimit: 'Giới hạn phòng ban',
            selectFile: 'Chọn File'
        },

        notificationV: {
            addNotification: 'Thêm thông báo',
            recipient: 'Người nhận',
            title: 'Tiêu đề',
            content: 'Nội dung',
            actions: 'Hành động',
            branch: 'Chi Nhánh',
            typeNotifi: 'Loại thông báo',
            employee: 'Nhân viên',
            selectEmployee: 'Chọn nhân viên',
            enterTitle: 'Nhập tiêu đề',
            summary: 'Tóm tắt',
            enterSummary: 'Nhập tóm tắt',
            contentPost: 'Nội dung bài viết',
            enterContentPost: 'Nhập nội dung bài viết',
            notificationType: 'Hình thức thông báo',
            viaApp: 'Thông báo qua ứng dụng',
            email: 'Thông báo qua email',
            phoneNumber: 'Thông báo qua số điện thoại',
            enterEmail: 'Nhập email nhận thông báo và nhấn enter',
            notifTime: 'Thời gian nhận thông báo',
            dragScroll: 'Kéo và di chuyển để chọn thời gian cài đặt',
            always: 'Luôn nhân thông báo',
            sendAll: 'Gửi tất cả',
            sendEachPerson: 'Gửi từng người',
        },

        device: {
            branch: 'Chi nhánh',
            status: 'Trạng thái cấp phát',
            statusDevice: 'Trạng thái thiết bị',
            filter: 'Lọc',
            addDevice: 'Thêm tài sản',
            device: 'Thiết bị',
            serialDevice: 'Số Serial',
            statusR: 'Trạng thái',
            receive: 'Người nhận',
            time: 'Thời gian',
            actions: 'Hành động',
            infoDevice: 'Thông tin tài sản',
            nameDevice: 'Tên tài sản',
            manufacture: 'Nhà cung cấp',
            firm: 'Hãng',
            code: 'Mã',
            dateInput: 'Ngày nhập',
            infoBou: 'Thông tin bổ sung',
            asset: 'Tài sản',
            employee: 'Nhân viên',
            noRowsToShow: 'Không có dữ liệu',
        },

        equipment: {
            branch: 'Chi Nhánh',
            filter: 'Lọc',
            addEquipment: 'Thêm vật dụng',
            item: 'Vật dụng',
            brand: 'Hãng',
            code: 'Mã',
            count: 'Số lượng',
            rest: 'Còn lại',
            actions: 'Hành động',
            all: 'Tất cả',
            unallocated: 'Chưa cấp phát',
            allocated: 'Đã cấp phát',
            active: 'Hoạt động',
            fix: 'Sữa chữa',
            crash: 'Đã hỏng',
            err: 'Có lỗi xảy ra !',
            itemName: 'Tên vật dụng',
            manufacture: 'Nhà cung cấp',
            infoAdd: 'Thông tin bổ sung',
            supplies: 'Cấp phát vật dụng',
            device: 'Thiết bị',
            recipient: 'Người nhận',
            time: 'Thời gian',
            reason: 'Lí do',
            asset: 'Tài sản',
            employee: 'Nhân viên',
            dateAdd: 'Ngày cấp',
            update: 'Cập nhật',
            allLocat: 'Cấp phát',
            updateSuccess: 'Cập nhật thành công',
            allLocatSuccess: 'Cấp phát thành công',
            noIten: 'Không tồn tại vật tư nào',
            noEmployee: 'Không tồn tại nhân viên nào',
            suppli: 'Vật tư',
            allocation: 'Cấp phát',
            recall: 'Thu hồi',
            stopWorking: 'Ngừng hoạt động',
            import: 'Nhập',
            export: 'Xuất'
        },

        menuCamera: {
            infoGroup: 'Thông tin nhóm camera',
            settingGroupCamera: 'Cài đặt nhóm camera',
            notFoundCameraMl: 'Không tìm thấy camera',
            searchMl: 'Tìm kiếm',
            listCameraMl: 'Danh sách camera trống',
            listCameraMlTo: 'Danh sách camera đã thêm trống',

            notifyCamera: 'Bạn chưa có chi nhánh nào, hãy tạo chi nhánh!',
            onMap: 'Bản đồ',
            setting: 'Cài đặt',
            record: 'Ghi hình',
            branch: 'Chi nhánh',
            groupCamera: 'Nhóm camera',
            listCamera: 'Danh sách camera',
            notification: 'Thông báo',
            playBack: 'Xem lại',
            videoType: 'loại video',
            time: 'Thời gian',
            dateCreated: 'Ngày tạo',
            viewMode: 'Chế độ xem',
            dashBoard: 'Thống kê',
            device: 'Thiết bị',
            cameraName: 'Tên camera',
            cameraBrand: 'Hãng camera',
            deviceCode: 'Mã thiết bị',
            cameraCode: 'Mã camera',
            enterDeviceCode: 'Nhập mã thiết bị',
            enterCameraCode: 'Nhập mã camera',
            streamFormat: 'Định dạng stream',
            previewImage: 'Hình ảnh xem trước: ',
            cameraStatus: 'Trạng thái camera',
            createCameraGroup: 'Tạo nhóm camera',
            addGroupCamera: 'Thêm nhóm camera',
            editGroupCamera: 'Sửa nhóm camera',
            deleteGroupCamera: 'Xóa nhóm camera',
            updateCamera: 'Cập nhật camera',
            createGroupCamera: 'Tạo mới nhóm camera',
            groupName: 'Tên nhóm',
            addCameraGroup: 'Thêm camera vào nhóm:',
            allCamera: 'Tất cả camera',
            addedCamera: 'Camera đã thêm',
            editCameraGroup: 'Chỉnh sửa nhóm camera',
            settingNotify: 'Cài đặt thông báo',
            receive: 'Nhận thông báo từ hệ thống',
            noRowsToShow: 'Không có dữ liệu',
            totalCamera: 'Số lượng camera',
            active: 'Đang hoạt động',
            waiting: 'Đang chờ',
            stopWorking: 'Ngừng hoạt động',
            noDevice: 'Không có thiết bị',
            branchCamera: 'Chi nhánh camera',
            updateTime: 'Thời gian cập nhật',
            createCamera: 'Tạo mới camera',
            organization: 'Tổ chức',
            organizationBranch: 'Chi nhánh',
            myGroup: 'Nhóm của bạn',
            groupShare: 'Nhóm được chia sẻ',
            share: 'Chia sẻ quyền truy cập nhóm',
            editShare: 'Sửa quyền truy cập nhóm',
            deleteShare: 'Xóa chia sẻ',
            deleteShareSucc: 'Xóa chia sẻ thành công',
            myCamera: 'Camera của tôi',
            myShareCamera: 'Camera được chia sẻ',
            preview: 'Xem trước'
        },

        onMap: {
            textTitleEditCamera: 'Chỉnh sửa bản đồ',
            textTitleCameraName: 'Camera: ',
            textTitleCameraErr: ' chưa được thêm vào bản đồ !',
            textTitleCamera: 'Camera đang được chọn: ',
            successMap: ' thành công !',
            updateSuccess: 'Cập nhật vị trí camera ' ,
            addSuccess: 'Thêm vị trí camera ',
            deleteSuccess: 'Xóa vị trí camera thành công !',
            textWarning: 'Bạn có chắc là muốn xóa vị trí camera ',
            titleWarning: 'Xác nhận xóa vị trí camera ',
            acceptText: "Xoá",
            cancelText: "Huỷ",
            textCancel: "Thoát chỉnh sửa",
            deletePositionCamera: "Xóa vị trí camera",
            editOnMap: "Chỉnh sửa bản đồ",
            search: "Tìm kiếm",
            errDelete: "Lỗi ! Chưa chọn Camera để xóa.",
            errDeleteInMap: "Lỗi ! Camera này chưa được thêm vào bản đồ."
        },


        warningMenuCamera: {
            titleWarning: 'Xác nhận xóa',
            textWarning: 'Bạn có chắc muốn xóa camera này không ?',
            textDeleteGroup: 'Bạn có chắc muốn xóa nhóm camera',
            acceptText: "Xoá",
            cancelText: "Huỷ",
            deleteSuccess: 'Xóa camera thành công',
            deleteGroupSuccess: 'Xoá nhóm camera thành công',
            notifySetting: 'Cài đặt thông báo thành công.',

        },

        notify: {
            notifyForm: 'Hình thức thông báo',
            period: 'Thời gian thông báo (Phút)',
            periodForm: 'Khoảng thời gian thông báo',
            notifyApp: 'Thông báo qua ứng dụng',
            notifyEmail: 'Thông báo qua email',
            insertEmail: 'Nhập email nhận thông báo và nhấn enter',
            notifyPhone: 'Thông báo qua số điện thoại',
            insertPhone: 'Nhập số điện thoại nhận thông báo và nhấn enter',
            timeNotify: 'Thời gian nhận thông báo',
            selectTime: 'Kéo và di chuyển để chọn thời gian cài đặt.',
            alwaysNotify: 'Luôn nhận thông báo',
            emailRequired: 'Vui lòng nhập địa chỉ email',
            phoneRequired: 'Vui lòng nhập số điện thoại',
            timeRequired: 'Vui lòng chọn thời gian thông báo',
        },

        weekTime: {
            monday: 'Thứ 2',
            tuesday: 'Thứ 3',
            wednesday: 'Thứ 4',
            thursday: 'Thứ 5',
            friday: 'Thứ 6',
            saturday: 'Thứ 7',
            sunday: 'Chủ nhật',
            copy: 'Sao chép',
            paste: 'Dán',
            textCopy: 'Sao chép dữ liệu thành công',
            textCopySecretKey: 'Sao chép mã bí mật thành công',
            textCopyNewPassword: 'Sao chép mật khẩu mới thành công',
            textCopyAccessKey: 'Sao chép chìa khóa truy cập thành công',
            textPaste: 'Dán dữ liệu thành công',
            setting: 'Cài đặt',
            timeUsed: 'Thời gian sử dụng',
            fromHour: 'Thời gian bắt đầu',
            toHour: 'Thời gian kết thúc',
            timeList: 'Danh sách thời gian sử dụng',
            invalidTime: 'Thời gian sai định dạng',
        },

        videosTypeOptions: {
            event: 'Sự kiện',
            auto: 'Tự động',
            autoNote:'Tổng hợp video do người dùng thao tác ghi hình lại tại màn camera',
            eventNote:'Tổng hợp video được ghi nhận lại 10 phút 1 lần 1 ngày',
        },

        cameraEventStatusTypes: {
            startRecording: 'Bắt đầu ghi hình',
            endRecording: 'Kết thúc ghi hình',
            intrusionDetection: 'Phát hiện xâm nhập',
            faceRecognition: 'Phát hiện gương mặt',
            cameraConnection: 'Kết nối camera',
            cameraDisconnect: 'Ngắt kết nối camera'

        },

        optionalCards: {
            offCamera: 'Ngắt kết nối',
            onCamera: 'Kết nối',
            detailCamera: 'Chi tiết camera',
            update: 'Cập nhật',
            notification: 'Thông báo',
            delete: 'Xóa',
            signUp: 'Đăng ký gói',
            historyPackage: 'Lịch sử yêu cầu',
            package: 'Gói dịch vụ',
        },

        textCamera: {
            textStartRecord: 'Bắt đầu ghi hình',
            textStopRecord: 'Đã dừng ghi hình',
            notCamera: 'Hiện tại không tồn tại camera nào',
            notifyCamera: 'Bạn chưa có Chi Nhánh. Hãy tạo Chi Nhánh ngay bây giờ !',
            undefined: 'Chưa xác định',
            textAddCamera: 'Để thêm Camera bạn cần có Chi Nhánh. Bạn sẽ được đưa tới trang tạo Chi Nhánh trong giây lát !',
            textLinkStream: 'Lỗi ! Link stream không tồn tại, đang để trống hoặc chưa đúng định dạng. Vui lòng nhập lại',
            errLinkStream: 'Link Stream Lỗi ! Tạm thời chưa hiển thị được ảnh xem trước',
            addCameraSuccess: 'Thêm camera thành công',
            unknown: 'Không xác định',
            connected: 'Kết nối',
            settingNotify: 'Cài đặt thông báo',
            settingNotifyOrganization: 'Cài đặt thông báo tổ chức',
            disConnect: 'Mất kết nối',
            waitingConnection: 'Đang chờ kết nối',
            textNotCamera: 'Bạn chưa có Chi Nhánh ! Vui lòng tạo Chi Nhánh để tiếp tục thêm Camera.',
            textNotGroupCamera: 'Bạn chưa có Chi Nhánh ! Vui lòng tạo Chi Nhánh để tiếp tục thêm Nhóm Camera.',
            cameraConnectSuccess: 'Kết nối thành công',
            cameraDisconnectSuccess: 'Ngắt kết nối thành công',
            cameraSuccess: 'camera thành công',
            wifiSuccess: "wifi thành công",
            qrSuccess: "mã QR thành công",
            notListCamera: 'Hiện tại danh sách camera đã trống, không thể hiển thị !',
            notGroupCamera: 'Chưa có camera nào được thêm vào nhóm',
            cameraGroupSuccess: ' nhóm camera thành công',
            deleteGroup: 'Bạn có chắc là muốn xóa nhóm',
            instructions: 'Hướng dẫn thêm camera vào nhóm !',
            instructionsNotification: 'Hướng dẫn nhận thông báo !',
            textInstruction: 'Chọn camera từ "Danh sách camera" sau đó kéo và giữ chuột đến "Camera đã thêm" rồi thả chuột.',
            textInstructionNotification: 'Tích chọn để nhận thông báo từ hệ thống, bỏ chọn để không nhận thông báo từ hệ thống.',
            err:'Lỗi',
            textInstructionOnMap: 'Chọn máy ảnh của nhóm từ danh sách bên trái và nháy chuột vào địa điểm trên bản đồ để thêm hoặc chỉnh sửa. Để xóa điểm đánh dấu, bạn hãy chọn một máy ảnh của nhóm từ danh sách bên trái sau đó bấm chọn "Xóa vị trí camera".',
            noneLinkStream: 'Camera không có link stream',
        },

        menuFaceRecognition: {
            addEvent: 'Thêm sự kiện',
            eventName: 'Tên sự kiện',
            branch: 'Chi nhánh'
        },

        textFaceRecognition: {
            undefined: 'Chưa xác định',
            noBranch: 'Hiện tại không tồn tại chi nhánh nào',
            updateEventSuccess: 'Cập nhật sự kiện thành công',
            addEventSuccess: 'Thêm mới sự kiện thành công',
            deleteSuccess: 'Xóa sự kiện thành công',
            titleWarning: 'Xác nhận xóa',
            deleteRecognition: 'Bạn có chắc là muốn xoá sự kiện nhận diện',
            cameraIsRequired: 'Bạn cần chọn camera',
            branchIsRequired: 'Bạn cần chọn chi nhánh',
            timeRequired: 'Bạn cần chọn thời gian sự kiện',
        },

        menuHistory: {
            branch: 'Chi nhánh',
            employee: 'Nhân viên',
            selectCamera: 'Chọn camera',
            time: 'Thời gian',
            filter: 'Tìm kiếm',
            createReport: 'Tạo báo cáo',
            employeeCode: 'Mã NV',
            employeeName: 'Tên NV',
            img: 'Hình ảnh',
            all: 'Tất cả',
            determine: 'Xác định',
            undefined: 'N/A',
            noBranch: 'Không tồn tại chi nhánh nào',
            featureAi: 'Tính năng AI',
            deviceName: 'Tên thiết bị',
            device: 'Thiết bị'
        },

        menuIntrusion: {
            branch: 'Chi nhánh',
            addEvent: 'Thêm sự kiện',
            eventName: 'Tên sự kiện',
            identification: 'Vùng nhận diện',
            utilization: 'Thời gian sử dụng',

            phoneNumber: "Số điện thoại",
            timeNoti: 'Thời gian thông báo',
            timeGetNoti: "Thời gian nhận thông báo",
            timeRangeGetNoti: "Khoảng thời gian giữa những lần nhận thông báo(phút)",
            getNoti: "Nhận thông báo",
            listGetEmail: "Danh sách email đã thêm",

            clearIdentified: 'Xóa vùng nhận diện',
            note: '* Chú ý:',
            painting: '- Chờ ảnh tải xong mới bắt đầu vẽ.',
            click: '- Click chuột trong vùng ảnh để vẽ khu vực.',
            rightClick: '- Bấm chuột phải để kết thúc vẽ khung hình.',
            nextButtonText: 'Tiếp theo',
            noBranch: 'Không tồn tại chi nhánh nào',
            undefined: 'Chưa xác định',
            selectCamera: 'Chọn camera',
            filter: 'Tìm kiếm',
            all: 'Tất cả',
            determine: 'Xác định',
            img: 'Hình ảnh',
            time: 'Thời gian',
            noSetting: 'Camera chưa được cài đặt',
            notEventName: "Tên sự kiện chưa được chọn.",
            notIdentify: 'Tọa độ nhận diện chưa được chọn.',
            notTimeUse: 'Thời gian sử dụng chưa được chọn.',
            updateEventSuccess: "Cập nhật sự kiện thành công",
            addEventSuccess: "Thêm mới sự kiện thành công.",
            notEmail: 'Email chưa được cài đặt.',
            identificationZone: 'Vùng nhận diện phải là đa giác',
            finishedArea: 'Vùng nhận diện đã vẽ xong',
            paintedArea: 'Vùng nhận diện đã được vẽ',
            paintReuired: 'Vui lòng vẽ vùng nhận diện',
            cameraExist: 'Camera đã được cài đặt sự kiện',
            timeRequired: 'Bạn cần chọn thời gian sự kiện',
            imgNotArea: 'Ảnh không chứa vùng nhận diện'
        },

        textIntrusion: {
            titleWarning: 'Xác nhận xóa',
            textDelete: ' Bạn có chắc là muốn xoá cài đặt xâm nhập ',
            acceptText: "Xoá",
            cancelText: "Huỷ",
            deleteSuccess: 'Xóa sự kiện thành công',
        },

        menuEvent: {
            // selectDevice: 'Thiết bị',
            dataNotFound: 'Không có dữ liệu',
            textNotifyLoadMore: 'Đã hiển thị hết danh sách camera ngày: ',
            time: 'Thời gian',
            event: 'Sự kiện',
            filter: 'Tìm kiếm',
            intrusionDetection: 'Phát hiện xâm nhập',
            faceDetection: 'Phát hiện khuôn mặt',
            system: 'Hệ thống',
            connect: 'Kết nối',
            disconnect: 'Mất kết nối',
            startRecording: 'Bắt đầu ghi hình',
            stopRecoding: 'Dừng ghi hình',
            unexplainable: 'Không xác định',
            selectCamera: 'Chọn camera',
            selectPad: 'Chọn pad',
            notCamera: 'Không có camera',
            other: 'khác',
            setting: 'Cài đặt thông báo',
            detail: 'Chi tiết sự kiện',
            statusCamera: 'Trạng thái camera',
            brandCamera: 'Hãng camera',
            maskDetection: 'Phát hiện không đeo khẩu trang',
            fireDetection: 'Báo cháy',
            undefined: 'Chưa xác định',
            branch: 'Chi nhánh',
            detect: 'Nhận diện',
            result: 'Kết quả',
            emotion: 'Cảm xúc',
            Spoofig: 'Giả mạo',
            noMask: 'Không đeo khẩu trang',
            mask: 'Đeo khẩu trang',
            auth: 'Xác thực',
            fake: 'Giả mạo',
            emoji: 'Cảm xúc',
            angry: 'Tức giận',
            happy: 'Vui vẻ',
            neutral: 'Bình thường',
            sad: 'Buồn',
            suprise: 'Ngạc nhiên',
            featureAi: 'Chức năng AI',
            searchCam: 'Nhập từ khoá tìm kiếm',
            selectDevice: 'Loại thiết bị'
        },

        profile: {
            manageOrgan: 'Quản lý tổ chức',
            resetPass: 'Đổi mật khẩu',
            getKeyApi: 'Cài đặt tài khoản',
            logout: 'Đăng xuất'
        },

        register: {
            successful: 'Chúc mừng bạn đã đăng ký thành công.',
            confirm: 'Vui lòng xác nhận email để hoàn tất đăng ký hoặc click vào đây để ',
            logIn: 'Đăng nhập',
            notReceive: 'Nếu bạn không nhận được Email.',
            toResend: 'Bấm vào đây để gửi lại',
            anAccount: 'Đăng ký tài khoản',
            organizationName: 'Tên tổ chức',
            phoneNumber: 'Số điện thoại',
            password: 'Mật khẩu',
            rePassword: 'Nhập lại mật khẩu',
            city: 'Tỉnh/Thành phố',
            district: 'Quận/ Huyện',
            commune: 'Xã / Phường',
            houseNumber: 'Số nhà',
            address: 'Địa chỉ',
            already: 'Nếu bạn đã có tài khoản, hãy nhấp vào đây để',
            register: 'Đăng ký',
            fullName: 'Tên đầy đủ',
            notValue: 'Không có giá trị hợp lệ nào',


        },

        playback: {
            listVideoDownload: "Danh sách tải xuống",
            listVideoDownloadEmpty: "Danh sách tải xuống trống",
            timeEmptyVideo: "Không có video tại thời điểm này",
            download: 'Tải xuống',
            zoomIn: 'Phóng to',
            zoomOut: 'Thu nhỏ',
            nextDay: 'Ngày hôm sau',
            preDay: 'Ngày hôm trước',
            play: 'Tiếp tục',
            pause: 'Dừng lại',
            volumeOn: 'Mở tiếng',
            volumeOff: 'Tắt tiếng',
            rewind: 'Tua lại',
            forward: 'Tua đi',
            pre10s: '10 giây trước',
            next10s: '10 giây sau',
            preVideo: 'Video trước',
            nextVideo: 'Video sau',
            notih265: 'Video không hoạt động chính xác ?',
            loaderrorh265: 'Video nén định dạng HEVC hiện tại chưa được hỗ trợ, vui lòng tải video xuống và sử dụng phần mềm hỗ trợ xem HEVC (Ví dụ: phần mềm VLC)'
        },
        getKey: {
            newPass: 'Mật khẩu mới',
            resetPass: 'Đặt lại mật khẩu ',
            getKeySuccess: 'Thay đổi mã truy cập cá nhân thành công !',
            createKeySuccess: ' Tạo mới mã truy cập cá nhân thành công !',
            titleTas: 'Thông báo',
            resetPassSuccess: 'Đặt lại mật khẩu thành công !',
            info: 'THÔNG TIN TÀI KHOẢN',
            userName: 'Tên tài khoản',
            thisKey: 'Đây là mã khóa bạn có thể sử dụng cho các trang Web hoặc cài đặt tài khoản của mình thông qua CDN API. Hãy đảm bảo giữ nó an toàn.',
            secretKey: 'Mã bí mật',
            accessKey: 'Chìa khóa truy cập',
            deleteApiKey: 'Thu hồi',
            deleteApiKeySuccess: 'Thu hồi mã truy cập cá nhân thành công',
            resetButton: 'Đặt lại mã truy cập cá nhân',
            createButton: 'Tạo mã truy cập cá nhân mới',
            err: 'Lỗi',
            errValidate: 'Bạn chưa chọn quyền hạn !',
            errValidateBranch: 'Bạn chưa chọn tổ chức !',
            listOrganization: 'Danh sách tổ chức',
            jurisdiction: 'Quyền hạn',
            administration: 'Quản trị',
            organization: 'Tổ chức',
            textTrain1: ' • Mỗi tài khoản người dùng sẽ có một bộ gồm mã bí mật (Secret_key) và chìa khóa truy cập (Access_key).',
            textTrain2: ' • Checksum được tạo ra bằng công thức SHA1 của: Timestamp + Secret_key.',
            textTrain3: ' • Header Request bao gồm các tham số: Accsess_key, Timestamp, Checksum.',
            textAttention: 'Chú ý :',
            acpetApi: 'Mã truy cập cá nhân',
            acpetApiAdmin: 'Cấp mã truy cập cá nhân',
            deleteSuccess: 'Thu hồi mã truy cập cá nhân thành công !'
        },

        resetPassword: {
            oldPass: 'Mật khẩu cũ',
            newPass: 'Mật khẩu mới',
            rePassword: 'Nhập lại mật khẩu mới',
            reOldPass: 'Nhập mật khẩu cũ',
            reNewPass: 'Nhập mật khẩu mới',
            retype: 'Nhập lại',
            resetPass: 'Đặt lại mật khẩu',
            textSuccess: 'Đặt lại mật khẩu thành công. Vui lòng đăng nhập lại !',
            textNotPass: 'Bạn chưa nhập mật khẩu mới, nhập lại',
            matched: 'Mật khẩu khớp',
            notMatched: 'Mật khẩu không khớp',
            pwdOldValid:'Hãy nhập mật khẩu hợp lệ rồi thử lại.',
            pwLength6:'Mật khẩu lớn hơn 6 kí tự',
            pwLength:'Độ dài mật khẩu',
            strong:'Mạnh',
            medium:'Trung bình',
            tooShort:'Quá ngắn',
            confirmPwdTooShort:'Mật khẩu khớp quá ngắn',
            validatorPwd:'Mật khẩu không dấu và khoảng cách',
        },

        warning: {
            titleWarning: 'Xác nhận xóa',
            textWarning: 'Bạn có chắc chắn muốn xóa',
            textBranch: 'chi nhánh?',
            acceptText: "Xóa",
            cancelText: "Hủy bỏ",
            textDeleSuccess: 'Xóa chi nhánh thành công',
            textSuccess: 'Thay đổi mật khẩu thành công',
            deleteSuccess: 'Xóa thành công',
        },

        pageLogin: {
            titleLogin: 'Quản lý camera tập trung trên nền tảng đám mây',
            rememberLogin: 'Ghi nhớ đăng nhập',
            logIn: 'Đăng nhập',
            noAcc: 'Bạn chưa có tài khoản đăng nhập ?',
            register: 'Đăng kí ngay',
            or: 'Hoặc',
            account: 'Tài khoản',
            password: 'Mật khẩu',
            errServer: 'Lỗi kết nối serve'
        },

        pageRegister: {
            successful: 'Chúc mừng bạn đã đăng ký thành công.',
            confirm: 'Vui lòng xác nhận email để hoàn tất đăng ký hoặc click vào đây để ',
            logIn: 'Đăng nhập',
            notReceive: 'Nếu bạn không nhận được Email.',
            toResend: 'Bấm vào đây để gửi lại',
            anAccount: 'Đăng ký tài khoản',
            organizationName: 'Tên tổ chức',
            phoneNumber: 'Số điện thoại',
            password: 'Mật khẩu',
            rePassword: 'Nhập lại mật khẩu',
            city: 'Tỉnh/Thành phố',
            district: 'Quận/Huyện',
            commune: 'Xã/Phường',
            houseNumber: 'Số nhà',
            address: 'Địa chỉ',
            already: 'Nếu bạn đã có tài khoản, hãy nhấp vào đây để',
            register: 'Đăng ký',
            fullName: 'Tên đầy đủ',
            notValue: 'Không có giá trị hợp lệ nào',


        },

        menuResetPassword: {
            oldPass: 'Mật khẩu cũ',
            newPass: 'Mật khẩu mới',
            rePassword: 'Nhập lại mật khẩu mới',
            reOldPass: 'Nhập mật khẩu cũ',
            reNewPass: 'Nhập mật khẩu mới',
            retype: 'Nhập lại',
            resetPass: 'Đặt lại mật khẩu',
            textSuccess: 'Đặt lại mật khẩu thành công. Vui lòng đăng nhập lại !',
            textNotPass: 'Bạn chưa nhập mật khẩu mới, nhập lại',
            matched: 'Mật khẩu đã trùng khớp',
            notMatched: 'Mật khảu không trùng khớp, vui lòng nhập lại!'

        },

        shareGroupCamera: {
            title: 'Chia sẻ nhóm camera',
            permission: 'Quyền hạn',
            email: 'Email người nhận',
            live: 'Xem trực tiếp',
            playback: 'Xem lại',
            event: 'Sự kiện',
            share: 'Chia sẻ',
            close: 'Đóng',
            validEmail: 'Email chưa đăng ký hệ thống, vui lòng kiểm tra lại.',
            shareComplete: 'Chia sẻ nhóm camera thành công.'
        },

        pagination: {
            to: 'Trên'
        },

        shareGroupCameraHistory: {
            title: 'Lịch sử chia sẻ',
            search: 'Tìm kiếm...',
            noData: 'Không có dữ liệu',
            organization: 'Tổ chức',
            permission: 'Quyền hạn',
            action: 'Hành động',
            close: 'Đóng',
            delete: `Bạn có chắc là muốn xoá chia sẻ cho`,
            successful: `Xoá Chia sẻ thành công.`,
        },

        deleteGroupCameraTree: {
            action: 'Hành động',
            close: 'Đóng',
            delete: `Bạn có chắc là muốn xoá nhóm`,
            successful: `Xoá nhóm thành công.`,
        },

        liveStream: {
            errPlayVideo: "Không thể phát video. Vui lòng thử lại sau.",
            playVideo: "Phát video",
            pauseVideo: "Tạm dừng",
            muteVideo: "Tắt tiếng",
            unmuteVideo: "Mở tiếng",
            fullScreen: "Toàn màn hình",
            closeFullScreen: "Thoát toàn màn hình",
            chooseCam: "Chọn camera",
            preCam: "Camera trước",
            nextCam: "Camera sau",
            capture: "Chụp ảnh",
            errorLink: "Camera đang tắt hoặc đường dẫn stream không chính xác."
        },

        title: {
            error: 'Lỗi'
        },

        policy: {
            leave: 'Nghỉ phép',
            holiday: 'Nghỉ lễ',
            detail: 'Chi tiết chính sách',
            create: 'Tạo mới',
            code: 'Mã chính sách',
            availability: 'KHẢ DỤNG',
            content: 'NỘI DUNG',
            leaveType: 'LOẠI NGHỈ PHÉP',
            participants: 'Người tham gia',
            editPolicy: 'Chỉnh sửa chính sách',
            policyName: 'Tên chính sách',
            type: 'Loại chính sách',
            annualLeave: 'Số lượng phép chuẩn hàng năm',
            policyContent: 'Nội dung chính sách',
            save: 'Lưu',
            cancel: 'Hủy',
            numberOfMonthWorked: 'Số tháng đã làm việc',
            extraDayOff: 'Số ngày nghỉ thưởng thêm',
            delete: 'Xóa'
        },

        cameraHistory: {
            title: {
                notification: 'Thông báo',
                cancelConfirmation: 'Xác nhận huỷ'
            },
            text: {
                pleaseDisconnect: 'Ngắt kết nối Camera trước khi thực hiện tác vụ này!',
                abortConfirm: 'Bạn có chắc chắn muốn huỷ gói '
            }
        },

        cardCustomer: {
            magneticCard: 'Thẻ từ',
            cardType: 'Loại thẻ',
            cardStatus: 'Trạng thái',
            addCard: 'Thêm mới',
            search: 'Tìm kiếm',
            allCard: 'Tất cả',
            customer: 'Khách hàng',
            employee: 'Nhân viên',
            unknown: 'Không xác định',
            id: 'Mã thẻ',
            startDate: 'Ngày bắt đầu',
            back: 'Quay lại',
            create: 'Tạo mới',
            chooseStartDate: 'Chọn ngày bắt đầu',
            using: 'Đang sử dụng',
            notUse: 'Không sử dụng',
            passers: 'Khách vãng lai',
            customerType: 'Loại khách hàng',
        },

        menuService: {
            nameServiceType: 'Tên dịch vụ'
        },

        menuWorspaceSetting: {
            nameIconApp: 'Tên',
            urlApp: 'Đường dẫn',
            orders: 'Số thứ tự',
            descriptionApp: 'Ghi chú',
            placeholder: 'Nhập dữ liệu ...',
        },

        settings: {
            addSetting: 'Cập nhật',
            close: 'Hủy',
            add: 'Thêm'
        }
    },


    en: {
        dashboard: {
            employee: "Staff",
            checkin: "Already check in",
            notCheckin: "Not yet check in",
            late: "Late",
            employeeWorkEarly: "Employees go to work first",
            empolyeeWorkLate: "Employees come to work late",
            today: "today.",
            emty: "Empty",
            yesterday: "yesterday.",
            times: 'Time',
            times7day: "Check-in time in 7 days.",
            checkinEarly: "Early check-in",
            checkinLate: "Checkin late",
            leave: "Leave",
            employeeLeave: "Employee resigns",
            meeting: "Meeting",
            bookMeeting: "Schedule a meeting room today.",
            event: "Event",
            allEvent: "All events for the month.",
            noCheckin: "No Check-in",
            workEarly: "Go early",
            workLate: "Go late",
            errSumEmployee: "There was an error getting the total number of employees",
            errMs: "An error occurred !",
            errSumEmployeeCheckin:  "There was an error taking the total number of employees to checkin.",
            errSumEmployeeLate: "There was an error taking the total number of employees who were late.",
            errSumEmployeeNotCheckin: "There was an error getting the total number of employees who have not checked in.",
            errSumEmployeeWorkEarly: "There was an error taking the total number of employees who arrived early.",
            errSumEmployeeWorkLate: "There was an error taking the total number of employees who were late.",
            errGetMeetingZoom: "There was an error taking the meeting room",
        },
        managementConfiguration:{
            selectEmployee: 'Select personnel',
            selectManager:'Select Manager',
            groupName:'Group name',
            update:'Update',
            addGroup:'Add Group',
            noData: 'No data',
            noDataMatching: 'No data matching',
        },
        heatmap: {
            title: 'Ivideon Heat maps are tools that help you analyze traffic inside your retail outlet. Identify popular and unpopular areas',
            feature_1: 'Learn the primary customer motion patterns in your retail outlet',
            feature_2: 'Increase sales off the shelf by placing goods in the most popular areas',
            feature_3: 'Optimize arrangement and assortment in “cold” areas',
            feature_4: 'Plan shelf and display placement to evenly distribute “flows” of visitors',
            feature_5: 'Assess the effectiveness of advertising by comparing the “temperature” before and after marketing campaigns begin',
            featurer_6: 'Plan the number of employees based on the retail outlet’s workload'
        },
        faceRecignition: {
            intro: 'Face recognition',
            title: 'Face recognition is a tool for real-time facial recognition. Identify customers and employees, analyze visitor data, and analyze demographic data',
            feature_1: 'Track customer traffic, demographics, and emotions',
            feature_2: 'Create and identify a list of VIP customers',
            feature_3: 'Timekeeping office staff',
            feature_4: 'Find people by photo, name, time and place',
            feature_5: 'A powerful recognition algorithm. Identification even when wearing a mask',
            featurer_6: 'Get quick identification notifications',
            setup: 'Camera settings'
        },

        aiRestrictedarea:{
            intro: 'Intrusion detection',
            title: 'Intrusion detection is a tool for real-time intrusion detection',
            feature_1: 'Fast and accurate intrusion detection thanks to AI',
            feature_2: 'Create a diverse and high-precision monitoring area',
            feature_3: 'Save on operating and installation costs',
            feature_4: 'Get Instant Intrusion Alert Notifications',
            feature_5: 'Intrusion object data storage',
            featurer_6: 'Safety monitoring where intrusion alarms are set',
            setup: 'Camera settings'
        },
        fireAlarm: {
            intro: 'Fire Warning',
            title: 'Artificial intelligence (AI) fire alarm is a tool to help you detect fire signs quickly with high accuracy, even in difficult environments. The area where the camera is installed will be protected safely without the support of other solutions',
            feature_1: 'Detect fire quickly at the source, minimizing damage',
            feature_2: 'Smart devices, artificial intelligence (AI) technology',
            feature_3: 'Save on operating and installation costs',
            feature_4: 'Protecting human life and property',
            feature_5: 'Instant Email and Phone Push Notifications',
            featurer_6: 'Smoke and fire recognition using AI'
        },
        minioStorage: {
            dateRange: 'Date range',
            totalFile: 'Total File',
            totalFileError: 'Total File error',
            day: 'days',
            totalStorage: 'Total storage',
            storage: 'Storage'
        },
        getDocument: {
            textCopyData: 'Copy data successful !',
            intro: 'Introduction',
            intro1: 'Add a camera',
            intro2: 'Update link stream',
            intro3: 'Update storage',
            intro4: 'Delete camera',
            intro5: 'Disconnect camera',
            intro6: 'Connect camera',
            intro7: 'List record',
            intro8: 'List camera',
            intro9: 'Camera package subscription history',
            intro10: 'Created ftp file',
            intro11: 'Search ftp file',
            intro12: 'List of camera packages',
            intro13: 'Create new ftp file + Create new camera',
            example: 'Example Request',
            detail1: 'User added 1 new camera.',
            detail2: 'User updates the stream link for the camera.',
            detail3: 'User updates package for camera.',
            detail4: 'User deletes the camera.',
            detail5: 'User stops connecting to stream camera.',
            detail6: 'User connects stream to camera.',
            detail7: 'User gets the saved video list.',
            detail8: 'User gets the list of cameras.',
            detail9: 'User obtains the subscription history of the cameras service pack.',
            detail10: 'User sends ftp of camera to Inviv system. Inviv check user and valid camera will record into the system.',
            detail11: 'User sends ftp and camera information to Inviv system. Inviv checks if the camera already exists in the system, if not, it will create a corresponding camera and record the sent ftp data.',
            detail12: 'User searches for submitted ftp files in Inviv system.',
            detail13: 'Users search for packages for cameras.',
            translate1a: 'Camera identifier',
            translate1b: 'Camera Name',
            translate1c: 'Link rtsp camera',
            translate1d: 'Package code',
            translate1e: 'Start time want to get data, data type is milliseconds',
            translate1f: 'End time want to get data, data type is milliseconds',
            translate1g: 'Page',
            translate1h: 'Number of records in 1 page',
            translate1l: 'Playback video type "session"(default) or "event"',
            translate1m: 'File size',
            translate1n: 'File Name',
            translate1i: 'Relative path',
            translate1k: 'Video start time, data type ISOString("2022-11-30T07:39:00.000+0000")',
            translate1j: 'Video end time, data type ISOString("2022-11-30T07:39:00.000+0000")',
            translate1p: 'Search start time, data type ISOString("2022-11-30T07:39:00.000+0000") by time Inviv recorded data',
            translate1o: 'Search end time, data type ISOString("2022-11-30T07:39:00.000+0000") by time Inviv recorded data',
            translate1q: 'Inviv side id',
            translate1w: 'Search start time, data type ISOString("2022-11-30T07:39:00.000+0000") by time Inviv recorded data',
            translate1r: 'Search end time, data type ISOString("2022-11-30T07:39:00.000+0000") by time Inviv recorded data',
            note1a:'Video archive automatically.',
            note1b: 'Video archived by user events.',
        },
        getHelpr: {
            analy: 'ANALYTICS MODULES',
            faceRecognition: 'Face recognition',
            titleFaceRecognition: 'Help › Face recognition',
            countingVisitors: 'Counting visitors',
            titleCountingVisitors: 'Help › Counting visitors',
            getDocument: 'API Docs '
        },
        getHelpCountingVisitors: {
            line1: 'Didn’t find what you need? Contact our',
            line2: ' tech support',
            line3: 'What affects calculation accuracy?',
            line4: 'The cloud tracks subject movement in the\n' +
                '                                        frame relative to a static background, counting the number of times a set line\n' +
                '                                        is crossed. For the best results, you need clearly visible subjects that are the\n' +
                '                                        only things moving.',
            line5: 'Camera selection',
            line6: 'Resolution',
            line7: 'Resolution doesn’t really play a role in how accurate calculations are. The frame that’s ultimately used is reduced to 160 x 90. To work normally, the counter needs a camera with a resolution of ',
            line8: 'at least 1.3 MP',
            line9: 'Light sensitivity',
            line10: 'The light sensitivity you need depends on how well lit your subjects are. Just make sure you don’t go any lower than',
            line11: ' 0.1 lux',
            line12: '. The less light there is shining on your subjects, the more light sensitivity you’ll need for your camera.',
            line13: 'Camera location',
            line14: 'Placement and height',
            line15: 'The camera should be hung ',
            line16: 'from the ceiling',
            line17: '. The camera lens should be aimed ',
            line18: 'perpendicular',
            line19: ' to the ground. If you can’t hang it from the ceiling, it’s okay if you find a spot where the angle is a bit less than vertical. The angle should not exceed ',
            line20: '±25 degrees',
            line21: 'The camera can be between ',
            line22: 'three and six meters off the ground',
            line23: 'Lighting',
            line24: 'The counter will think large shadows (or glares) are subjects. For the algorithm to work correctly, the camera should be pointed at an area with ',
            line25: 'even lighting',
            line26: 'Poor or excessive lighting can make it hard to pick the subjects out against the background. For the minimum lighting level in the area where you’ll be counting subjects, aim for ',
            line27: '100 lux',
            line28: ' (use the Lux Light Meter app to get an approximate reading).',
            line29: 'If the area is too dark, you’ll have to set up additional light sources.',
            line30: 'Irrelevant objects',
            line31: 'The frame should be ',
            line32: 'free of extraneous movement',
            line33: ' (opening doors, escalators, etc.) given that the algorithm can count any moving object toward the final number.',
            line34: 'Camera settings',
            line35:'Frame rate per second',
            line36: 'The counter might not catch fast-moving subjects if the camera’s frame rate is too low. We recommend a rate of ',
            line37: 'at least 20 frames per second',
            line38: 'Counter settings',
            line39: 'Crossing line',
            line40: 'For the counter to work correctly, you need to set a ',
            line41: 'line',
            line42: ' that subjects will cross to register. The line doesn’t have to be straight and can be drawn any way you want.',
            line43: 'Average object size',
            line44: 'To maximize the counter’s accuracy, set an ',
            line45: 'average object size',
            line46: ' for the frame. The right value for this parameter depends on your particular context.',
            line47: 'Exclusion areas',
            line48: 'If there are areas in the frame with movement you don’t want to track, create ',
            line49: 'exclusion areas',
            line50: ' in the settings.',
            line51: 'Installation height',
            line52: 'To get the most out of your counter settings, set the',
            line53: 'exact height',
            line54: ' you installed it at.',
            line55: 'Troubleshooting',
            line56: 'No count at all',
            line57: 'What to do:',
            line58: ' ● Make sure your plan is paid for.',
            line59: ' ● Check the camera’s position, especially how high it is.',
            line60: ' ● Measure the lighting.',
            line61: ' ● Set a crossing line.',
            line62: ' ● Check the average object size.',
            line63: ' ● Delete exclusion areas.',
            line64: 'Excess events',
            line65: 'Problem',
            line66: 'The counter is erring on the high side',
            line67: 'What to do:',
            line68: ' ● Make sure there aren’t any extra moving objects in the frame.',
            line69: ' ● Add exclusion areas.',
            line70: ' ● Check the lighting (glare, shadows).',
            line71: ' ● Check the camera’s position, especially how high it is.',
            line72: ' ● Check the average object size.',
            line73: ' ● Delete superfluous crossing lines.',
            line74: 'Connection types',
            line75: 'Method 1: Via the cloud ',
            line76: 'You can connect a visitor counter to any camera you have available in the web application ',
            line77: 'The cloud-based counter is simpler to install and use, it’s updated regularly, and it’s cheaper than competing options.',
            line78: 'Method 2: Via an edge device',
            line79:'As soon as you buy a',
            line80:' People Counter 3D, separate plans for it are made available in the web application.',
            line81: 'Edge devices don’t require an internet connection and deliver more exact numbers, though they’re pricier.',
            line82: 'Too few events',
            line83: 'Problem',
            line84: 'The counter is erring on the low side',
            line85: 'What to do:',
            line86: ' ● Check the camera’s position, especially how high it is.',
            line87: ' ● Measure the lighting.',
            line88: ' ● Check the average object size.',
            line89: ' ● Delete exclusion areas.',
            line90: ' ● Add crossing lines.',


        },
        getHelpFaceRecognition: {
            header: 'The Help section didn’t help? Contact our',
            headerContact: ' tech support',
            tabs1: 'What affects recognition quality?',
            tabs1Info: 'During recognition, the cloud compares a\n' +
                '                                        freeze frame pulled from the camera with the pictures of people you’ve already\n' +
                '                                        uploaded. Both sides should be high-quality and meet our requirements for the\n' +
                '                                        best result.',
            tabs1Detail1: 'Freeze frames from the camera',
            tabs1Detail1Info1: 'Sufficient picture resolution',
            tabs1Detail1Info11: 'Faces in pictures should take up at least',
            number200: '200 × 200',
            tabs1Detail1Info111: 'pixels. Low resolution = little information on facial points = high error rate during comparison.',
            tabs1Detail1Info2: 'No blurring',
            tabs1Detail1Info22:'Pictures should be clear',
            sharp: 'and sharp',
            tabs1Detail1Info222: '. When there’s a lot of blurring in the frames, there’s less usable information about the face and therefore a higher chance of an error.',
            tabs1Detail1Info3: 'Even lighting',
            tabs1Detail1Info33: 'Faces should be',
            evenlylist: 'evenly lit',
            tabs1Detail1Info333:', without heavy shadows or glare. Darkened or washed-out spots on faces can cause problems gathering information about them.',
            threeAngles: 'Three Angles',
            tabs1Detaiil2: 'Pictures of people',
            youNeed: 'You need at least three angles of the people you add to your lists: ',
            facingForward: 'facing forward, left side profile, and right side profile',
            thatWillHelp: '. That will help the system recognize faces from a variety of angles.',
            pictureQuality: 'Picture quality',
            pictureQuality1: 'Pictures of faces should meet our quality requirements: a resolution of at least ',
            pictureQuality2: '200 ×200 pixel',
            pictureQuality3: ', clear and without ',
            pictureQuality4: 'blurring',
            pictureQuality5: ', evenly lit, ',
            pictureQuality6: 'and without shadows or glare',

            tabs2: 'Tips on camera placement and settings',

            tabs2s: 'To make sure you get the best freeze frames, pay careful attention to your camera selection, placement, and configuration.',

            tabs2D1: 'Camera selection',
            tabs2D1i1: 'Resolution',
            tabs2D1i2: 'The resolution you should pick depends on how far away you’ll be needing to recognize faces. Try to stick to a ratio of ',
            tabs2D1i3: '1 MP per meter ',
            tabs2D1i4: ' between the camera and the subject.',
            tabs2D1i12: 'Light sensitivity',
            tabs2D1i22: 'The light sensitivity you need depends on how well lit your subjects will be. Regardless, don’t go any lower than',
            tabs2D1i32: ' 0.1 lux.',
            tabs2D1i42: ' The less light there will be shining on your subjects, the more light sensitivity you’ll need for your camera.',

            tabs2D2: 'Camera settings',
            tabs2D2i1: 'Shutter speed',
            tabs2D2i2: 'Don’t go anywhere above',
            tabs2D2i3: ' 1/200',
            tabs2D2i4: '. If you do, your pictures will be blurred, leading to problems with recognition.',
            tabs2D2i12: 'Bit rate',
            tabs2D2i22: 'Make sure you stay above',
            tabs2D2i32: ' 2 Mbps',
            tabs2D2i42: ' so you don’t lose any quality. The higher your resolution, the faster your bit rate will need to be.',

            tabs2D3: 'Camera placement',
            tabs2D3i1: 'Distance',
            tabs2D3i2: 'The farthest you can set your camera up away from your subjects depends on its resolution. Try to stick to a ratio of ',
            tabs2D3i3: '1 MP per meter ',
            tabs2D3i4: 'between the camera and the subject.',
            tabs2D3i12: 'Height',
            tabs2D3i22: 'Our recommendation for how high up to install your camera is to aim for',
            tabs2D3i32: ' 1.8 meters',
            tabs2D3i42: ' (average human height). If you don’t have anything around that height that you can attach it to, you can drop a special rod down from the ceiling to hang right about there.',
            tabs2D3i13: 'Lighting',
            tabs2D3i23: 'Heavy shadows (or glare) on faces reduce the amount of visual information we can collect, making the system prone to mistakes and false positives. For the minimum lighting level in the area where you’ll be recognizing faces, aim for ',
            tabs2D3i33: '100 lux ',
            tabs2D3i43: '(use the app Lux Light Meter to get an approximate reading). If the area is too dark, you’ll have to set up additional light sources.',
            tabs2D3i14: 'Angle',
            tabs2D3i24: 'Faces are hard to recognize from the side, when they’re looking down, or from beneath because of how there isn’t enough visual information in the final frames (for example, profiles only show half the face), so make sure you set your cameras up such that most faces will be coming',
            tabs2D3i34: ' right at them',

            tabs2D4: 'Detection settings',
            tabs2D4i1: 'Minimum face size',
            tabs2D4i2: 'To make sure your freeze frames have enough resolution (at least',
            tabs2D4i3: ' 200 × 200 pixel',
            tabs2D4i4: '), it’s important to correctly configure the minimum size for detected faces. The right value for this parameter depends on your particular context.',
            tabs2D4i12: 'Detection areas',
            tabs2D4i22: 'If you have areas in the frame where you don’t need to detect faces (a different sales stand, for instance), make sure you limit your',
            tabs2D4i32: ' detection area in the settings',

            tabs3: 'Problems and solutions',

            tabs3D1: 'Lots of false positives or missed detections',
            tabs3D1i1: 'What to do:',
            tabs3D1i2: ' ● Correctly install and configure your camera.',
            tabs3D1i3: ' ● Boost the minimum face size',

            tabs3D2: 'No detections at all',
            tabs3D2i1: ' ● Make sure your plan is paid for.',
            tabs3D2i2: ' ● Check the analytics settings on your local server ',
            tabs3D2i3: ' ● Lower the quality threshold.',
            tabs3D2i4: ' ● Reduce the minimum face size ',
            tabs3D2i5: ' ● Increase the detection area.',

            tabs3D3: 'Too few detections',
            tabs3D3i1: 'Not all the faces in the frame are being detected.',
            tabs3D3i2: ' ● Lower the quality threshold.',
            tabs3D3i3: ' ● Reduce the minimum size for detected faces in the frame',
            tabs3D3i4: ' ● Increase the detection area.',

            tabs3D4: 'Superfluous detections',
            tabs3D4i1: 'You’re getting detections you don’t care about. For example, people outside or in the background.',
            tabs3D4i2: ' ● Increase the minimum size for detected faces in the frame ',
            tabs3D4i3: ' ● Reduce the detection area.',
            tabs3D5i4: ' ● Get closer to your subjects.',

            tabs3D5: 'Insufficient freeze frame resolution',
            tabs3D5i1: 'Your freeze frames are low-quality because of their resolution (less than 200 × 200 pixel).',
            tabs3D5i2: ' ● Increase the minimum size for detected faces in the frame',
            tabs3D5i3: ' ● Buy a camera with more resolution.',

            tabs3D6: 'Blurry freeze frames',
            tabs3D6i1: 'Your freeze frames come out blurry and anything but crisp.',
            tabs3D6i2: ' ● Reduce your camera’s shutter speed.',
            tabs3D6i3: ' ● Set up additional light sources in the area.',
            tabs3D6i4: ' ● Buy a camera with more light sensitivity.',

            tabs3D7: 'Dark freeze frames (heavy shadows on the faces)',
            tabs3D7i1: ' ● Increase your camera’s shutter speed.',
            tabs3D7i2: ' ● Set up additional light sources in the area.',
            tabs3D7i3: ' ● Buy a camera with more light sensitivity.',

            tabs3D8: 'Washed-out freeze frames (glare on the faces)',
            tabs3D8i1: ' ● Reduce your camera’s shutter speed.',
            tabs3D8i2: ' ● Get rid of some light sources in the area.',


        },
        navMenu: {
            manageOrgan: 'Organization Management',
            organizationInformation: 'Organization Information',
            branch: 'Branch',
            personnel: 'Personnel',
            servicePack: 'Service Package',
            signUpService: 'Register Service',
            requestHistory: 'Request History',
            customerManagement: 'Customer',
            customer: 'Customer',
            historyInOut: 'History in out',
            customerInOut: 'In Out History Customer',
            cameraManage: 'Camera Manage',
            stream: 'Stream',
            playBack: 'Play Back',
            groupCamera: 'Group Camera',
            event: 'Events',
            intelligentHandling: 'AI - Intelligent handling',
            intrusiveSettings: 'Intrusive Settings',
            infiltrationHistory: 'Infiltration History',
            faceRecognition: 'Face Recognition',
            intrusionDetection: 'Intrusion Detection',
            faceRecognitionSetting: 'Face Recognition Setting',
            listCameras: 'List Camera',
            organization: 'Organization',
            funcAuthority: 'Functional authority',
            storageCamera: 'Storage Camera',
            fireAlarm: 'Fire alarm settings',
            heatMap: 'Heat Map',
            //update
            leave: 'Leave',
            manageEmployee: 'Manage Employee',
            resourceManagement: 'Management Resource',
            functionRoom: 'Multipurpose Room',
            manageCamera: 'Manage Camera',
            checkIn: 'Timekeeping',
            wifiCheckIn: 'Wifi',
            qrCheckIn: 'QR',
            shift: 'Shift',
            shiftDaybyday: 'Day Shift Work',
            workMore: 'Overtime',
            historyCheckIn: 'Timekeeping history',
            complaintLetter: 'Complaint',
            manageNew: 'Internal communications',
            mNew: 'News',
            notification: 'Notification',
            manageDevice: 'Asset',
            listDevice: 'Property List',
            historyDevice: 'Property history',
            manageEquipment: 'Equipment',
            listEquipment: 'List Equipment',
            editEquipment: 'Distributing supplies',
            historyEquipment: 'History Equipment',
            leaveType: 'Leave Type',
            leaveDate: 'Leave Date',
            comment: 'Comment',
            today: 'Today',
            before: 'Before',
            after: 'After',
            nameMeeting: 'Name Meeting Room',
            location: 'Location',
            capacity: 'Number of people',
            purpose: 'Purpose',
            participants: 'Participants',
            meetingDate: 'Meeting Date',
            meetingName: 'Name Meeting',
            meeting: 'Meeting',
            startTime: 'Start Time',
            endTime: 'End Time',
            selectAttendees: 'Select Attendees',
            leavePermission: 'Leave permission',
            unauthorizedAbsences: 'Unauthorized absences',
            allDay: 'All day',
            byShift: 'By shift',
            activeStatus: 'Active Status',
            policy: 'Policy',
            managePermision: 'Manage Permision',
            managePosition: 'Manage Position',
            externalDevice: 'External device',
            cardCustomer: 'Magnetic card',
            department: 'Department',
            manageServiceType: 'Service Type',
            manageServicePacks: 'Service Packs',
            incentives: 'Incentives',
            manageIncentives: 'Incentives, voucher',
            redemption: 'Redemption',
            feedback: 'Feedback',
            comboService: 'Combo service',
            bookingSchedule: 'Booking schedule',
            appointmentSchedule:'Appointment schedule',
            bookingScheduleHistory: 'Booking schedule history',
            newfeed: 'Newfeed',
            newfeedMenuSub:'Newfeed',
            postsWaitingForApproval: 'Posts waiting for approval',
            postsApproved: 'Posts approved',
            postsRejected: 'Posts rejected',
            restrictedKeywords: 'Restricted Keywords',
            customerApp: 'Customer app',
            salesOffice1: 'Sales department 1',
            salesOffice2: 'Sales department 2',
            employeeSources: 'Employee sources',
            otherSources: 'Other souces',
            callCenter: 'Call center',
            overviewCallCenter: 'Overview',
            consultingHistory: 'Consulting history',
            callHistory: 'Call history',
            monitorCallCenter: 'Call monitor',
            customerIdentification: 'Customer identification',
            waitingForReception: 'Waiting for reception',
            receptionStep: 'Reception step',
            consultingStep: 'Consulting step',
            feeCollectionStep: 'Fee collection step',
            paraclinicalExaminationStep: 'Paraclinical examination step',
            completedStep: 'Completed step',
            cardClass: 'Card class',
            /*Care Module*/
            careDashboad: 'Dashboad Care',
            careSms: 'SMS Care',
            careEmail: 'Email Care',
            addNewsSms: 'Thêm SMS',
            smsBrandName: 'SMS Brand Name',
            smsMessenger: 'Tin nhắn',
            smsStatusDone: 'SMS đã chạy',
            smsStatus: 'SMS chưa chạy',
            /*End Care Module*/
            potentialCustomers:'Potential Customers',
            opportunisticCustomers:'Opportunistic Customers',
            managementConfiguration:'Management Configuration',
            bookingCustomers: 'Khách hàng đặt lịch',
            arriveCustomers: 'Khách hàng đến phòng khám',
            pancakeConfig: 'Config pancake',
            medicalExamination: 'QUY TRÌNH',
            newEvent: 'TIN TỨC, SỰ KIỆN',
            settings: 'SETTINGS',
            generalCustomers: 'General customer',
            callMonitoring:'Call monitoring',
            loginSession: 'Login session',
            activeCall:'Active call',
        },
        notification: {
            pleaseEnter: 'Please enter ',
            timelineNotification: 'timeline notification',
            years: ' years',
            year: ' year',
            day: ' day',
            days: ' days',
            hour: ' hour',
            hrs: ' hrs',
            min: ' min',
            mins: ' mins',
            secAgo: ' sec ago',
            justNow: 'just now',
            ago: 'ago',
        },
        inputTime: {
            today: 'Today',
            yesterday: 'Yesterday',
            weekAgo: '1 week ago',
            monthAgo: '1 month ago',
            lastWeek: 'Last week',
            lastMonth: 'Last month',
            months3Ago: '3 month ago',
            months6Ago: '6 month ago',
            yearAgo: '1 year ago'
        },

        employeeScreen: {
            branch: 'Branch',
            department: 'Department',
            employeeId: 'Employee ID',
            firstName: 'Lastname',
            lastName: 'Name',
            requiredEmployeeId: 'Employee ID cannot be blank',
            requiredFirstName: 'First name cannot be blank',
            requiredLastName: 'Last name cannot be blank',
            requiredUsername: 'Username cannot be empty',
            requiredBirth: 'Birthday cannot be blank',
            requiredEmail: 'Email cannot be blank',
            requiredStreet: 'House number cannot be empty',
            requiredImage: 'Employees need at least one face-recognition photo',
        },

        message: {
            error: "Error",
            success: "Success",
        },

        download: {
            textDownload: 'Download app Inviv HRM',
            scan: 'SCAN CODE TO DOWNLOAD',
        },

        wifi: {
            addWifi: 'Add wifi',
            nameWifi: 'Wifi name',
            status: 'Status',
            actions: 'Actions',
            work: 'Activate',
            notWork: 'Inactive',
            branch: "Branch",
            sttWork: 'Active status'
        },

        qrCode: {
            addQr: 'Add QR Code',
            branch: 'Branch',
            qrEncoded: 'Qr Encoded String',
            status: 'Status',
            actions: 'Actions',
            work: 'Activate',
            notWork: 'Inactive',
            sttWork: 'Active status',
            qrCode: 'QR code',
            exportF: 'Export file',
        },

        workShift: {
            restTime: 'Rest time',
            branch: 'Branch',
            addWork: 'Add Shifts',
            group: 'Group',
            shiftName: 'Shift Name',
            begin: 'Begin',
            finish: 'Finish',
            flexibleTime: 'Flexible Time',
            actions: 'Actions',
            branchName: 'Branch Name',
            setting: 'Setting',
            groupName: 'Group Name',
            workingDay: 'Working day',
            startTime: 'Start time',
            endTime: 'End time',
            flexible: 'Flexible (Minutes)',
            workThrough: 'Working day by day',
            allowAdvance: 'Allow advance check-in (minutes)',
            allowInlater: 'Allow check-in later (minutes)',
            allowCheckOutIn : 'Allow to check out in advance (minutes)',
            allowCheckOutLater: 'Allow to check out later (minutes)',
            endInNextDay: 'End in next day',
        },

        workShiftByDay: {
            branch: 'Branch',
            employeeCode: 'Employee code',
            employeeName: 'Staffs name',
            email: 'Email',
            phoneNumber: 'Phone number',
            actions: 'Actions',
            setting: 'Settings',
            settingShiftByDay: 'Day shift setting',
            name: 'Full name',
            addShift: 'Add shifts',
            groupShift: 'Name of the working group',
            nameShift: 'Shift name',
            startTime: 'Start time',
            endTime: 'End time',
            flexible: 'Flexible (Minutes)',
            workThrough: 'Working day by day',
            allowAdvance: 'Accept check-in in advance (minutes)',
            allowInlater: 'Accept check-in later (minutes)',
            allowCheckOutIn : 'Accept check out in advance (minutes)',
            allowCheckOutLater: 'Accept check out later (minutes)',
            workDay: 'Working day',
            settingAdvance: 'Advanced settings',
            infoShift: "Shift information",
            title: 'Title',
            endInNextDay: 'End in next day',
        },

        overTime: {
            branch: 'Branch',
            employee: 'Staff',
            status: 'Status',
            times: 'Time',
            fitel: 'Filter',
            createWork: 'Create overtime shift',
            employeeCode: 'Employee Code',
            employeeName: 'Staffs name',
            branchName: 'Branch name',
            createDate: 'Date created',
            actions: 'Actions',
            reseon: 'Reason',
            beginDate: 'Shift start date',
            startTime: 'Start time',
            endTime: 'End time',
            endDayWork: 'Shift end date',
            approved: 'Approved',
            wait: 'Waiting'
        },

        menuPackage: {
            historyPackageTitle: 'Request History',
            signUpPackage: 'Register Service',
            experience: 'Sign up to experience the service now.',
            package: 'Package',
            packageHistoryDate: 'yours will expire on',
            packageHistory: ' yours has expired',
            renew: 'To track new data, renew your plan now',
            limit: 'Limit',
            storageTime: 'Storage time',
            day: 'day',
            storageCapacity: 'Storage capacity',
            totalCamera: 'Total of cameras',
            totalCameraAI: 'Total of camera using AI',
            quality: 'Quality',
            date: 'Date',
            cost: 'Cost',
            functional: 'Functional AI',
            generalInformation: 'General Information',
            organizationName: "Organization Name",
            packageName: 'Package name',
            endDate: 'Expiration date',
            expired: 'Expired',
            storageDate: 'storage date',
            useAI: 'Camera using AI',
            resolution: 'for resolution',
            titlePackage: 'History & status processing requests for expansion, upgrade, and renewal of packages.',
            search: 'Search',
            noRowsToShow: 'No Data',
            softwarePackage: 'Software package name',
            requestDate: 'Request Date',
            price: 'Price',
            status: 'Status',
            actions: 'Actions',
            singUpPackage: 'Sign up for a software package',
            singUpSuccess: 'success',
            null: 'Null',
            shop: 'Shop',
            company: 'Company',
            education: 'Education',
            packageInactive: 'Not activated',
            packageExpire: 'Expires',
            packageDay: 'date',
            time: 'Time (month)',
            amount: 'Amount (vnd)',
            paymentType: 'Payment type',
            modifiedDate: 'Modified date',
            payment: 'Payment',
            packageInformation: 'Package Information',
            numberOfMonth: 'Number of Month',
            packagePolicy: 'Package policy:',
            packagePolicy1: '- Each package can be used for a maximum of 1 month.',
            packagePolicy2: '- Package does not automatically renew, can manage and cancel the package at any time.',
            packagePolicy3: '- The following upgrade package will be automatically activated when the old package expires.',
            cameraInfo: 'Camera Information',
            cameraName: 'Camera Name',
            payInfo: 'Payment Information',
            durationPack: 'Duration Package',
            totalPrice: 'Total Price',
            month: 'month',
            vnd: 'VND',
            momoWallet: 'MoMo Wallet',
            requestAdmin: 'Request Admin',
            amountTrial: '** Number of times to use Trial package: ',
        },

        menuOrganization: {
            keySetting: 'Account Setting',
            organization: 'Organization',
            organizationName: 'Organization Name',
            acronym: 'Acronym',
            phoneNumber: 'Phone Number',
            organizationType: 'Organization Type',
            expiredDate: 'Expired Date',
            city: 'Province/ City',
            district: 'District',
            commune: 'Commune/ Ward',
            houseNumber: 'House Number',
            streetName: 'Building, Street Name',
            approveEmployeeFullName: 'Approved By',
            address: 'Full Address',
            activeStatus: 'Active Status',
            addBranch: 'Add Branch',
            branchName: 'Branch Name',
            branchType: 'Branch Type',
            branch: 'Branch',
            addEmployee: 'Add Employee',
            employeeCode: 'Employee Code',
            employeeName: 'Employee Name',
            displayLeaveDate: 'Leave Date',
            displayLeaveTime: 'Leave Time',
            status: 'Status',
            personalInformation: 'Personal Information',
            lastName: 'Last Name',
            firstName: 'First Name',
            birthday: 'Date of birth',
            createDepartment: 'Create Department',
            department: 'Department',
            gender: 'Gender',
            location: 'Location',
            employeeType: 'Employee Type',
            salary: 'Salary',
            faceData: 'Face data (10 photos)',
            workingTime: 'Working Time',
            autoGenerate: 'Automatically create shifts',
            group: 'Group',
            shift: 'Shift',
            Manager: 'Manager',
            working: 'Working',
            authority: 'Authority',
            addFace: 'Add face data.',
            all: 'All',
            rePass: 'Reset Password',
            newPass: 'New Password',
            principalOffice: 'Principal Office',
            null: 'Null',
            userName: 'User Name',
            dataUpdate: 'Data update successful',
            noBranch: 'There are currently no branches available',
            validUsername: 'valid username',
            userExists: 'Username already exists',
            cannotName: 'Department name cannot be left blank.',
            theFuture: 'The date of birth should not be in the future.',
            geolocation: 'Geolocation has not been selected',
            succPersonnel: 'successful personnel',
            oldData: 'Old data will be overwritten. Do you want to overwrite?',
            noOption:'Sorry, not matching options',
            email: 'Email',
            emptyList: 'Empty list',
            locationMap: 'Location',
            enterAddress: 'Enter address',
            updateOrganizationSS: 'Organization update successful',
            usernameAvailable: 'Username available',
            pleaseSelectBranch: 'Please select "Branch" before adding personnel!',
            cameraEmpty: "All camera",

            startWork: 'Work Start',
        },

        warningMenuOrganization: {
            titleWarning: 'confirm deletion',
            textWarning: 'Are you sure you want to delete the employee?',
            textBranchWarning: 'Are you sure you want to delete the branch',
            textBranch: '?',
            acceptText: "Delete",
            cancelText: "Cancel",
            textDeleteSuccess: 'Delete a successful branch',
            deleteSuccess: 'Successfully deleted',
            textSuccess: 'Change your password successfully',
            textBranchSuccess: 'Successful branch',
            anErr: 'An error has occurred',
            newDepartments: 'Add new departments',
            success: 'success.',
            emptyEmployee: 'Employee list is empty',
        },

        playback: {
            listVideoDownload: "List of downloads",
            listVideoDownloadEmpty: "The download list is empty",
            timeEmptyVideo: "No video at the moment",
            download: 'Download',
            zoomIn: 'Zoom in',
            zoomOut: 'Zoom out',
            nextDay: 'Next day',
            preDay: 'Pre day',
            play: 'Play',
            pause: 'Pause',
            volumeOn: 'Volume on',
            volumeOff: 'Volume off',
            rewind: 'Rewind',
            forward: 'Forward',
            pre10s: '10 seconds ago',
            next10s: '10 seconds later',
            preVideo: 'Previous Video',
            nextVideo: 'Next Video',
            notih265: 'Video not working correctly?',
            loaderrorh265: 'The HEVC format compressed video is not currently supported, please download the video and use the software that supports HEVC viewing (Ex: VLC software)',
        },

        menuNewFeed: {
            search: 'Search',
            create: "Create",
            stt: "No.",
            user: "Username",
            posts: "Posts",
            createdDate: "Created date",
            modifiedDate: "Modified date",
            approvedDate: "Approved date",
            status: "Status",
            actions: "Actions",
            wait: "Wait",
            done: "ddone",
            reject: "Reject",
            interactionCount: "Like",
            commentCount: "Comment",
            restrictedKeywords: "Restricted keywords",
            addKeyword: 'Add restricted keywords successfully',
            updateKeyword: 'AUpdate restricted keywords successfully',
            type: 'Posts type',
        },

        menuCustomer: {
            addCustomer: 'Add Customer',
            customerCode: 'Customer Code',
            customerName: 'Customer Name',
            phoneNumber: 'Phone Number',
            dateCreated: 'Date Created',
            customerInfo: 'Customer Information',
            city: 'Province/ City',
            district: 'District',
            commune: 'Commune/ Ward',
            houseNumber: 'House Number',
            address: 'Full Address',
            faceData: 'Face Data',
            identityCard: 'Identity Card',
            all: 'All',
            undefined: 'Undefined',
            customer: 'Customer',
            time: 'Time:',
            noRowsToShow: 'No Data',
            img: 'Image',
            timeOfRecord: 'The Point Of Recognition',
            addCustomerSS: 'Add customer successfully',
            updateCustomerSS: 'Customer update successful',
            cardNumber: 'Card Code',
            contactInfo: 'Customer info',
            customerType: 'Customer type',
            organization: 'Organization',
            actions: 'Actions',
            addEmployee: 'Add employee',
            dayOfBirth: 'Day of birth',
            age: 'Age',
            weight: 'Weight',
            gender: 'Gender',
            email: 'Email',
            ethnic: 'Ethnic',
            career: 'Career',
            stt: 'No.',
            job: 'Job',
            status: 'Status',
            employee: 'Employee',
            sourceType: 'Source customer',
            nanoCode: 'Customer code',
            birthday: 'Day of birthday',
            nickName: 'Nickname',
            partnerType: 'Partner',
        },

        notify: {
            period: 'Period (Minute)',
            periodForm: 'Notification period',
            notifyForm: 'Notification form',
            notifyApp: 'Notifications via the app',
            notifyEmail: 'Email notifications',
            insertEmail: 'Insert the email receiving the notification and press enter',
            notifyPhone: 'Notifications by phone number',
            insertPhone: 'Insert the phone number receiving the notification and press enter',
            timeNotify: 'Notification time',
            selectTime: 'Drag and move to select the installation time.',
            alwaysNotify: 'Always get notifications',
            emailRequired: 'Please enter an email',
            phoneRequired: 'Please enter phone number',
            timeRequired: 'Please select a notification time',
        },

        weekTime: {
            monday: 'Monday',
            tuesday: 'Tuesday',
            wednesday: 'Wednesday',
            thursday: 'Thursday',
            friday: 'Friday',
            saturday: 'Saturday',
            sunday: 'Sunday',
            copy: 'Copy',
            paste: 'Paste',
            textCopy: 'Copy data successfully',
            textPaste: 'Paste data successfully',
            textCopySecretKey: 'Copy the secret code successfully',
            textCopyNewPassword: 'Copy new password successfully',
            textCopyAccessKey: 'Copy access key successfully',
            setting: 'Setting',
            timeUsed: 'Time used',
            fromHour: 'From hour',
            toHour: 'To hour',
            timeList: 'Time list',
            textEndTime: 'The end time should be greater than the start time.',
            textCopySuccess: 'Copy data',
            textPasteSuccess: 'Paste data',
            success: 'successful',
            invalidTime: 'Time is in the wrong format',

        },

        videosTypeOptions: {
            event: 'Events',
            auto: 'Auto',
            autoNote:'Synthesize video recorded by users at the camera screen',
            eventNote:'Synthesize recorded videos every 10 minutes a day'
        },


        timeKeeping: {
            branch: 'Branch',
            employee: 'Staff',
            alreadyCheckin: 'Already check in',
            late: 'Late',
            times: 'Time:',
            filter: 'Filter',
            createReport: 'Create report',
            employeeCode: 'Employee Code',
            fullName: 'Full Name',
            comeBackSoon: 'Come Back Soon',
            leaveWork: 'Leave',
            typeCheckin: 'Type Of Timekeeping',
            actions: 'Actions',
            afterWork: 'Off shift',
            onShift: 'In shift',
            date: 'Date',
            shift: 'Shift',
            detailCheck: 'Timekeeping details',
            approve: 'Approve',
            historyExport: 'Report generation history'
        },

        equipment: {
            branch: 'Branch',
            filter: 'Filter',
            addEquipment: 'Add Equipment',
            item: 'Item',
            brand: 'Brand',
            code: 'Code',
            count: 'Amount',
            rest: 'Rest',
            actions: 'Actions',
            all: 'All',
            unallocated: 'Unallocated',
            allocated: 'Allocated',
            active: 'Active',
            fix: 'Repair',
            crash: 'Broken',
            err: 'An error occurred !',
            itemName: 'Name the item',
            manufacture: 'Manufacture',
            infoAdd: 'Additional information',
            supplies: 'Distributing supplies',
            device: 'Equipment',
            recipient: 'Recipient',
            time: 'Time',
            reason: 'Reason',
            asset: 'Asset',
            employee: 'Staff',
            dateAdd: 'Date Range',
            update: 'Update',
            allLocat: 'Allocation',
            updateSuccess: 'Update successful',
            allLocatSuccess: 'Issuance successful',
            noIten: 'No materials exist',
            noEmployee: 'There are no employees',
            suppli: 'Supplies',
            allocation: 'Allocation',
            recall: 'Recall',
            stopWorking: 'Stop working',
            import: 'Import',
            export: 'Export'
        },

        menuCamera: {
            infoGroup: 'Camera group information',
            settingGroupCamera: 'Camera group settings',
            notFoundCameraMl: 'Camera not found',
            searchMl: 'Search',
            listCameraMl: 'Camera list is empty',
            listCameraMlTo: 'The list of added cameras is empty',

            onMap: 'OnMap',
            notifyCamera: 'You don\'t have a branch yet. Let\'s create a branch now! ',
            setting: 'Setting',
            record: 'Record',
            branch: 'Branch',
            groupCamera: 'Group Camera',
            listCamera: 'List Camera',
            notification: 'Notification',
            playBack: 'Play Back',
            videoType: 'Video Of Type',
            time: 'Time:',
            dateCreated: 'Date Created',
            viewMode: 'View Mode',
            dashBoard: 'Dashboard',
            device: 'Device',
            cameraName: 'Camera Name',
            cameraBrand: 'Brand Camera',
            deviceCode: 'Device code',
            cameraCode: 'Camera code',
            enterDeviceCode: 'Enter device code',
            enterCameraCode: 'Enter camera code',
            streamFormat: 'Stream Format',
            cameraStatus: 'Camera Status',
            createCameraGroup: 'Create camera group',
            addGroupCamera: 'Add group camera',
            editGroupCamera: 'Edit group camera',
            deleteGroupCamera: 'Delete group camera',
            updateCamera: 'Update Camera',
            createGroupCamera: 'Create a new camera group',
            groupName: 'Group Name',
            addCameraGroup: 'Add camera to group',
            allCamera: 'All cameras',
            addedCamera: 'Camera added',
            receive: 'Receive notifications from the system',
            noRowsToShow: 'No data',
            totalCamera: 'Total of camera',
            noDevice: 'No device',
            active: 'Active',
            waiting: 'Waiting',
            stopWorking: 'Stop working',
            branchCamera: 'Branch camera',
            updateTime: 'Update time',
            createCamera: 'Create New Camera',
            organization: 'Organization',
            organizationBranch: 'Organization branch',
            myGroup: 'My group',
            groupShare: 'Group share',
            share: 'Share access to group',
            editShare: 'Edit access right to group',
            deleteShare: 'Delete share',
            deleteShareSucc: 'Delete Share successful.',
            myCamera: 'My camera',
            myShareCamera: 'Shared camera',
            preview: 'Preview'
        },

        updateInout: {
            branch: 'Branch',
            employee: 'Employee',
            status: 'Status',
            time: 'Time',
            filter: 'Filter',
            create: 'Create',
            createReport: 'Generate report',
            employeeCode: 'Employee code',
            employeeName: 'Staffs name',
            date: 'Date',
            shift: 'Shift',
            timeInOut: 'Time in and out',
            reason: 'Reason',
            actions: 'Actions',
            employeeStaff: 'Personnel',
            dateTimekeeping: 'Timekeeping complaint date',
            shiftWork: 'Shift',
            timeStart: 'Start time',
            timeEnd: 'End time',
            humanCom: 'Comment reviewers',
            choseCamera: 'Select Camera',
            image: 'Image',
            preTime: 'Time',
            export: 'Generate report',
        },

        news: {
            addNews: 'Add posts',
            humanCreate: 'Creator',
            department: 'Part',
            departmentB: 'Department',
            title: 'Title',
            content: 'Content',
            actions: 'Actions',
            typePost: 'Post type',
            roleView: 'Permission to view',
            titlePost: 'Post title',
            contentPost: 'Content',
            moreSelect: 'Many choices',
            addSelect: 'More options',
            humanSelect: 'The one who chooses',
            selection: 'Selection',
            enterTitle: 'Enter title',
            selectDepartment: 'Choose a department',
            evaluate: 'Evaluate',
            news: 'News',
            poll: 'Poll',
            departmentLimit: 'Department limit',
            selectFile: 'Select File',
        },

        cameraEventStatusTypes: {
            startRecording: 'Start recording',
            endRecording: 'End of recording',
            intrusionDetection: 'Intrusion Detection',
            faceRecognition: 'Face Recognition',
            cameraConnection: 'Camera Connection',
            cameraDisconnect: 'Disconnect the camera'
        },

        notificationV: {
            addNotification: 'Add notification',
            recipient: 'Recipient',
            title: 'Title',
            content: 'Content',
            actions: 'Actions',
            branch: 'Branch',
            typeNotifi: 'Notification Type',
            employee: 'Staff',
            selectEmployee: 'Choose an employee',
            enterTitle: 'Enter title',
            summary: 'Summary',
            enterSummary: 'Enter summary',
            contentPost: 'Content',
            enterContentPost: 'Enter the article content',
            notificationType: 'Notification Type',
            viaApp: 'Notifications via the app',
            email: 'Email notifications',
            phoneNumber: 'Notification by phone number',
            enterEmail: 'Enter the email to receive the notification',
            enterPhone: 'Enter the phone number to receive the notification',
            notifTime: 'Notification Time',
            dragScroll: 'Drag and scroll to select the setting time',
            always: 'Always get notifications',
            sendAll: 'Send All',
            sendEachPerson: 'Send Each Person',
        },

        device: {
            branch: 'Branch',
            status: 'Allocation status',
            statusDevice: 'Device Status',
            filter: 'Filter',
            addDevice: 'Add property',
            device: 'Equipment',
            serialDevice: 'Serial number',
            statusR: 'Status',
            receive: 'Recipient',
            time: 'Time',
            actions: 'Actions',
            infoDevice: 'Property Information',
            nameDevice: 'Equipment name',
            manufacture: 'Manufacture',
            firm: 'Firm',
            code: 'Code',
            dateInput: 'Date Added',
            infoBou: 'Additional information',
            asset: 'Equipment',
            employee: 'Employee',
            noRowsToShow: 'No Data'
        },

        optionalCards: {
            offCamera: 'Disconnect',
            onCamera: 'Connection',
            detailCamera: 'Detail Camera',
            update: 'Update',
            notification: 'Notification',
            delete: 'Delete',
            signUp: 'Sign up for the package',
            historyPackage: 'Service pack request history',
            package: 'Package',
        },

        textCamera: {
            textStartRecord: 'Start recording',
            textStopRecord: 'Stop recording',
            notCamera: 'There are currently no cameras available',
            undefined: 'Undefined',
            textAddCamera: 'To add a camera you need a Branch. You\'ll be sent to the Branch Creation page in a moment!',
            textLinkStream: 'Error! Link stream does not exist, is blank or malformed. Please re-enter',
            errLinkStream: 'Link Stream Error ! Temporarily unable to display preview image.',
            addCameraSuccess: 'Successfully added camera',
            unknown: 'Unknown',
            connected: 'Connected',
            disConnect: 'Disconnect',
            waitingConnection: 'Waiting for connection',
            textNotCamera: 'You do not have a Branch yet! Please create a Branch to continue adding Cameras.',
            textNotGroupCamera: 'You do not have a Branch yet! Please create a Branch to continue adding Camera Groups.',
            cameraConnectSuccess: 'Connection is successful.',
            cameraDisconnectSuccess: 'Disconnect successful.',
            cameraSuccess: 'successful camera',
            createGroupCamera: 'Create a new camera group',
            notGroupCamera: 'No cameras have been added to the group yet',
            cameraGroupSuccess: ' successful camera group',
            deleteGroup: 'Are you sure you want to delete group',
            wifiSuccess: "wifi successfull",
            qrSuccess: "QR code successfull",
            settingNotify: 'Notification settings',
            settingNotifyOrganization: 'Organization notification settings',
            instructions: 'Instructions for adding cameras to the group !',
            instructionsNotification: 'Instructions for receiving notifications !',
            textInstruction: 'Select camera from "camera list" then hold down the mouse to move and drag to "added camera"',
            textInstructionOnMap: 'Select your teams camera from the list on the left and click on a location on the map to add or edit. To remove a marker, select a group camera from the list on the left then tap Delete camera location.',
            textInstructionNotification: 'Set checkbox to receive notifications from the system, uncheck to not receive notifications from the system.',
            notListCamera: 'Currently the camera list is empty, cannot be displayed!',
            err:'Error',
            noneLinkStream: 'Camera has no link stream',
        },


        onMap: {
            textTitleEditCamera: 'Editing the map',
            textTitleCameraName: 'Camera: ',
            textTitleCameraErr: ' not added to the map !',
            textTitleCamera: 'Camera is selected: ',
            successMap: ' successfully !',
            updateSuccess: 'Update camera position ' ,
            addSuccess: 'Added camera position ',
            deleteSuccess: 'Delete camera location successfully !',
            textWarning: 'Are you sure you want to delete this camera location ',
            titleWarning: 'Confirm removal of camera location ',
            acceptText: "Delete",
            cancelText: "Cancel",
            textCancel: "Cancel Editing",
            deletePositionCamera: "Remove Camera Location",
            editOnMap: "Map Editing",
            search: "Search",
            errDelete: "Error ! Have not selected Camera to delete.",
            errDeleteInMap: "Error ! This camera has not been added to the map yet."

        },

        warningMenuCamera: {
            titleWarning: 'confirm deletion',
            textWarning: 'Are you sure you want to delete the camera?',
            textDeleteGroup: 'Are you sure you want to delete the camera group',
            deleteGroupCamera: 'Delete camera group successfully',
            deleteGroupSuccess: 'Delete camera group successfully',
            acceptText: "Delete",
            cancelText: "Cancel",
            deleteSuccess: 'Delete the camera successfully.',
            notifySetting: 'Successful notification setting.'
        },

        warningMenuCustomer: {
            titleReset: 'Confirm Password Reset',
            titleWarning: 'confirm deletion',
            textDeleteCustomer: 'Are you sure you want to delete the customer?',
            acceptText: "Delete",
            cancelText: "Cancel",
            deleteSuccess: 'Delete customer successfully',

        },

        genderOption: {
            unknown: 'Unknown',
            male: 'Male',
            female: 'Female'
        },

        employeeTypeOptions: {
            unknown: 'Unknown',
            trainee: 'Trainee',
            officialStaff: 'Official Staff',
        },

        statusActive: {
            agree: 'Agree',
            waiting: 'Waiting',
            decline: 'Decline',
            cancel: 'Cancel',
            systemProcessing:'The system is processing',
            error: 'Error',
            approve: 'Approve',
            approveNow: 'Approve now',
            waitingApprove: 'Pending',
            waitingUpgrade: 'Waiting for upgrade',
            abort: 'Abort',
            expries: 'Expries',
            failure: 'Failure',
            approved: 'Approved',
            canceled: 'Canceled'
        },

        employeeStatus: {
            working: 'Working',
            offWork: 'Off work'
        },

        root: {
            organizationName: 'Organization Name',
            organizationType: 'Organization Type',
            phoneNumber: 'Phone Number',
            status: 'Status',
            actions: 'Actions',
            titleWarning: 'Confirm delete',
            deleteOrgan: 'Are you sure you want to delete the organization',
            deleteSuccess: 'Delete organization successfully',
            stopWorking: 'Stop working',
            active: 'Active',
            shop: 'Shop',
            company: 'Company',
            education: 'Education',
            organizationAcronym: 'Abbreviations',
            fullAddress: 'Full Address',
            houseNumber: 'House Number',
            street: 'Street',
            expiredDate: 'Expired Date',
            city: 'Province/City',
            district: 'District',
            commune: 'Commune/Ward',
            address: 'Full Address',
            partner: 'Partner',
            activeStatus: 'Active Status',
            null: 'Null',
            all: 'All',
            successOrganization: 'successful organization',
            noRowsToShow: 'No Data',
            cameraName: 'Camera Name',
            stream: 'Stream',
            storage: 'Storage',
            allOrgan: 'All Organizations',
            yes: 'Yes',
            no: 'No',
            organization: 'Organization',
            cameraBrand: 'Camera Brand',
            streamFormat: 'Stream Format',
            cameraSuccess: 'successful camera',
            addFunc: 'Add Functions',
            functionName: 'Function Name',
            limitFunction: 'Are you sure you want to remove the limit function',
            removeFunction: 'Remove limit function successfully',
            displayName: 'Display Name',
            functionalSuccess: 'limited functional success',
            addPack: 'Add service pack',
            deletePack: 'Are you sure you want to remove the package?',
            deletePackSucc: 'Delete the package successfully',
            packageName: 'Package Name',
            totalCamera: 'Total Camera',
            price: 'Price',
            date: 'Date',
            softwarePackage: 'Software package name',
            storageTime: 'Storage time',
            totalCameraAI: 'Total of camera using AI',
            priceVND: 'Price(VND)',
            storedData: 'Stored data',
            storeData: 'Stored data(GB)',
            resolution: 'Resolution',
            packageTerm: 'Package Term',
            usingAI: 'Using the AI function',
            selectFunction: 'Select function',
            day: 'day',
            successfulSoftware: 'successful software package',
            titlePackage: 'History & status processing requests for expansion, upgrade, and renewal of packages.',
            requestDate: 'Request Date',
            requestConsent: 'Confirm consent request.',
            acceptPack: 'Are you sure you want to accept the package upgrade request',
            fewMinutes: 'Request upgrade successfully',
            cancellation:'Confirm cancellation request.',
            request:'Are you sure you want to cancel the package upgrade request',
            refused:'Refused to upgrade the package successfully.',
            create: 'Create',
            update: 'Update',
            cameraAlias: 'Camera alias',
        },

        button: {
            titleRessetAc: 'Are you sure you will reset your password ?',
            loadMore: 'Load more',
            request: 'Request',
            cancel: 'Cancel',
            update: 'Update',
            create: 'Create',
            employee: 'Employee',
            edit: 'Edit',
            actions: 'Actions',
            delete: 'Delete',
            back: 'Back',
            updateAI: 'Update AI data',
            addEmployee: 'Add Employee',
            addNew: 'Add New',
            save: 'Save',
            agree: 'Agree',
            abort: 'Abort',
            notNow: 'Not Now',
            filter: 'Filter',
            reload: 'Reload',
            addCamera: 'Add Camera',
            preview: 'Preview',
            close: 'Close',
            add: 'Add',
            addOrganization: 'Add Organization',
            titleDelete:'Confirm delete',
            check: 'Check',
            settingsOrganization:'Organization notification settings',
            search: 'Search ...',
            addMeetingRoom: 'Add Meeting Room',
            scheduleMeeting: 'Schedule a meeting',
            payment: 'Payment',
            outOf: 'Out of turns',
            updatePackage: 'Update Package',
            off_on: 'Off/On',
            historyInOut: 'Entrance and exit history',
            addCard: 'Add card',
            confirm: 'Confirm',
            complete: 'Complete',
            details: 'Details',
            phone: 'Call',
            approved: 'Approved',
            rejected: 'Rejected',
            call: 'Call',
            runSms: 'Send message',
            detailSms: 'Mesage details',
            stopSms: 'Message running',
            message: 'Texting',
            remainer: 'Remainer',
        },

        warning: {
            titleWarning: 'Confirm delete',
            textWarning: 'Are you sure you want to delete the  ',
            textBranch: 'branch?',
            acceptText: "Delete",
            cancelText: "Cancel",
            textDeleSuccess: 'Delete branch successfully',
            textSuccess: 'Change password successfully',
            deleteSuccess: 'Successful delete'

        },

        textErr: {
            account: 'Account',
            password: 'Password',
            organizationName: 'Organization Name',
            organizationAcronym: 'Abbreviations',
            fullAddress: 'Full Address',
            houseNumber: 'House Number',
            street: 'Street',
            zipCode: 'Zip Code',
            adminAccount: 'Admin Account',
            phoneNumber: 'Phone Number',
            organizationType: 'Type of organization',
            expiredDate: 'Expired Date',
            organizationBranchName: ' Branch Name',
            cameraName: 'Camera Name',
            streamUrl: 'Link stream',
            employeeCode: 'Employee code',
            LastName: 'LastName',
            FirstName: 'FirstName',
            birthday: 'Date of birth',
            type: 'Type',
            deviceType: 'ASSET',
            brand: 'Brand',
            model: 'Code',
            serialNumber: 'Serial number',
            totalQuantity: 'Total quantity',
            importDate: 'Date Added',
            supplier: 'Supplier',
            fromDate: 'From Date',
            toDate: 'To Date',
            assignDate: 'Date of issue',
            reason: 'Reason',
            workShiftName: 'Work shift name',
            workDayOfWeek: 'Working day',
            startHour: 'Start hour',
            endHour: 'End hour',
            bufferTime: 'Flex time',
            groupName: 'Group name',
            allowCheckInBefore: 'Allow CheckIn Before',
            allowCheckInAfter: 'Allow CheckIn After',
            allowCheckOutBefore: 'Allow Check Out Before',
            allowCheckOutAfter: 'Allow Check Out After',
            equipmentType: 'Item name',
            dailyWorkName: 'Work name',
            startDate: 'Start date',
            endDate: 'End date',
            dailyWorkDetailName: "Item Name",
            methodCheck: "Method",
            completionCriteria: "Job requirements",
            placeDetailName: "Place name",
            level: "Priority level",
            address: "Full Address",
            areaDetailName: "Area name",
            nameRestrictedarea: "Event name",
            fromHour: "From hour",
            toHour: "To hour",
            date: "Timekeeping complaint date",
            newPassword: "New Password",
            cameraGroupName: "Group Name",
            qrCode: "QR code",
            titleNotify: "Insert title",
            abbreviate: "Insert abbreviate",
            name: "Name of meeting room",
            location: 'Location',
            reservationName: "Meeting name",
            purpose: "Purpose",
            dateBegin: "Meeting date",
            meetingRoom: "Meeting room",
            participants: 'Participants',
            timeKeepingType: 'Partner',
            oldPassWord: 'Old passWord',
            newPassWord: 'New passWord',
            reNewPassWord: 'Re-enter a new password',
            title: 'Title',
            email: 'Email',
            rePassword: 'Password',
            fullName: 'Full Name',
            salary: 'Salary',
            manageMeeting: 'Management Meeting Room',
            bookAMeeting: 'Meeting Schedule',
            modifiedDate: 'Modified Date',
            time: 'Time'
        },

        menuFaceRecognition: {
            addEvent: 'Add Event',
            eventName: 'Event Name',
            branch: 'Branch'
        },

        textFaceRecognition: {
            undefined: 'Undefined',
            noBranch: 'Currently no branch exists',
            updateEventSuccess: 'Update event successful',
            addEventSuccess: 'Add new success event',
            deleteSuccess: 'Delete successful event',
            titleWarning: 'Delete Confirmation',
            deleteRecognition: 'Are you sure you want to delete the recognition event',
            cameraIsRequired: 'Camera is required',
            branchIsRequired: 'Branch is required',
            timeRequired: 'You need to select event time',
        },

        menuHistory: {
            branch: 'Branch',
            employee: 'Employee',
            selectCamera: 'Select the camera',
            time: 'Time',
            filter: 'Filter',
            createReport: 'Generate Report',
            employeeCode: 'Employee Code',
            employeeName: 'Employee Name',
            img: 'Image',
            all: 'All',
            determine: 'Determine',
            undefined: 'N/A',
            noBranch: 'Currently no branch exists',
            featureAi: 'Function AI',
            deviceName: 'Device Name',
            device: 'Device Type'
        },

        menuIntrusion: {
            branch: 'Branch',
            addEvent: 'Add Event',
            eventName: 'Event Name',
            phoneNumber: "Phone number",
            timeNoti: 'Notice time',
            timeGetNoti: "Notification time",
            timeRangeGetNoti: "Time between notifications (minutes)",
            getNoti: "Get notifications",
            listGetEmail: "Email list added",
            identification: 'Identification Area',
            utilization: 'Utilization time',
            clearIdentified: 'Delete an identified area,',
            note: '* Note:',
            painting: '- Wait for the picture to load before start painting',
            click: '- Click in the picture area to draw the area.',
            rightClick: '- Right click to finish drawing the frame.',
            nextButtonText: 'Next',
            noBranch: 'Currently no branch exists',
            undefined: 'Undefined',
            time: 'Time',
            selectCamera: 'Select the camera',
            filter: 'Filter',
            all: 'All',
            determine: 'Determine',
            img: 'Image',
            noSetting: 'Camera is not setting',
            notEventName: "The name of the event has not been chosen.",
            notIdentify: "The identifying coordinate has not been selected.",
            notTimeUse: 'The time of use has not been selected.',
            updateEventSuccess: 'Successful event update',
            addEventSuccess: 'Add new success event.',
            notEmail: 'Email has not been set up.',
            identificationZone: "The identification zone must be polygonal.",
            finishedArea: 'The identification area is finished.',
            paintedArea: "The identification area is painted.",
            paintReuired: 'The identification is required',
            cameraExist: 'Camera event installed',
            timeRequired: 'You need to select event time',
            imgNotArea: 'The image does not contain the recognition area'
        },

        textIntrusion: {
            titleWarning: 'Confirm delete',
            textDelete: 'Are you sure you want to remove the intrusive settings ',
            acceptText: "Delete",
            cancelText: "Cancel",
            deleteSuccess: 'Delete successful event',
        },

        menuEvent: {
            // selectDevice: 'Select device',
            dataNotFound: 'Data not found',
            textNotifyLoadMore: 'The list of day cameras has been displayed: ',
            time: 'Time',
            event: 'Event',
            filter: 'Filter',
            intrusionDetection: 'Intrusion Detection',
            faceDetection: 'Face Detection',
            system: 'System',
            connect: 'Connect',
            disconnect: 'Disconnect',
            startRecording: 'Start Recording',
            stopRecoding: 'Stop Recoding',
            unexplainable: 'Unexplainable',
            selectCamera: 'Select the camera',
            selectPad: 'Select the pad',
            notCamera: 'Do not have camera',
            other: 'Other',
            setting: 'Notification settings',
            detail: 'Event detail',
            statusCamera: 'Camera status',
            brandCamera: 'Brand camera',
            maskDetection: 'Mask Detection',
            fireDetection: 'Fire Detection',
            undefined: 'Undefined',
            branch: 'Branch',
            detect: 'Detect',
            result: 'Result',
            emotion: 'Emotion',
            Spoofig: 'Spoofig',
            noMask: "Don't wear a mask",
            mask: 'Wear a mask',
            auth: 'Authentication',
            fake: 'Fake',
            emoji: 'Emotion',
            angry: 'Angry',
            happy: 'Happy',
            neutral: 'Normal',
            sad: 'Sad',
            suprise: 'Surprise',
            searchCam: 'Enter keyword',
            selectDevice: 'Device Type'
        },

        profile: {
            manageOrgan: 'Organization Managemen',
            resetPass: 'Reset Password',
            getKeyApi: 'Account Setting',
            logout: 'Logout'
        },

        login: {
            titleLogin: 'Centralized camera management on Cloud platform',
            rememberLogin: 'Remember login',
            logIn: 'Log In',
            noAcc: 'Do not have an account ?',
            register: 'Register now !',
            or: 'or',
            account: 'Account',
            password: 'Password',
            errServer: 'Server Error'
        },

        register: {
            successful: 'Congratulations on your successful registration.',
            confirm: 'Please confirm your email to complete registration or click here to',
            logIn: 'Log In',
            notReceive: 'If you do not receive the Email.',
            toResend: 'Click here to resend',
            anAccount: 'Register an account',
            organizationName: 'Organization Name',
            phoneNumber: 'Phone Number',
            password: 'Password',
            rePassword: 'Re-enter a password',
            city: 'Province/ City',
            district: 'District',
            commune: 'Commune/ Ward',
            houseNumber: 'House Number',
            address: 'Full Address',
            already: 'If you already have an account, click here to',
            register: 'Register'

        },

        getKey: {
            newPass: 'New Password',
            resetPass: 'Reset Password ',
            acpetApi: 'Personal Access Tokens',
            acpetApiAdmin: 'Provide Personal Access Tokens',
            deleteSuccess: 'Revoke Personal Access Tokens Successfully!',
            textAttention: 'Attention :',
            getKeySuccess: 'Change personal access tokens successfully !',
            createKeySuccess: 'Personal access token generation successful !',
            titleTas:'Notification',
            resetPassSuccess: 'Password reset successful !',
            info: 'ACCOUNT INFORMATION',
            userName: 'Account Name',
            thisKey: 'This is key you can to programmatically update your sites or account settings via CDN API. Make sure to keep it safe',
            resetButton: 'Reset personal access tokens',
            createButton: 'Create personal access tokens',
            err: 'Error',
            secretKey: 'Secret Key',
            accessKey: 'Access Key',
            deleteApiKey: 'Revoke',
            deleteApiKeySuccess: 'Revoke Personal Access Tokens Successfully',
            errValidate: 'You have not selected the authority !',
            errValidateBranch: 'You have not selected an organization !',
            listOrganization: 'List of organizations',
            jurisdiction: 'Jurisdiction',
            administration: 'Administration',
            organization: 'Organization',
            textTrain1: ' • Each account user will have a set that includes a secret code (Secret_key) and an access key (Access_key).',
            textTrain2: ' • Checksum is generated using SHA1 formula: Timestamp + Secret_key.',
            textTrain3: ' • The Request header includes the following parameters: Accsess_key, Timestamp, Checksum.',
        },

        resetPassword: {
            oldPass: 'Old Password',
            newPass: 'New Password',
            rePassword: 'Re-enter a password',
            reOldPass: 'Enter old password',
            reNewPass: 'Enter new password',
            retype: 'Retype',
            resetPass: 'Reset Password',
            textSuccess: 'Reset the password successfully. Please log in again!',
            textNotPass: 'You haven\'t entered a new password, re-entered',
            matched: 'Passwords match',
            notMatched: 'Passwords do not match',
            pwdOldValid:'Enter a valid password and try again.',
            pwLength6:'Password is more than 6 characters',
            pwLength:'Password strength',
            strong:'Strong',
            medium:'Medium',
            tooShort:'Too Short',
            confirmPwdTooShort:'Confirmation password is too short',
            validatorPwd:'Passwords without signs and spaces',
        },

        shareGroupCamera: {
            title: 'Share group camera',
            permission: 'Permission',
            email: 'Email target',
            live: 'Live',
            playback: 'Play back',
            event: 'Event',
            share: 'Share',
            close: 'Close',
            validEmail: 'Email is not registered to the system, please check again.',
            shareComplete: 'Share camera group complete.'
        },

        shareGroupCameraHistory: {
            title: 'Share camera history',
            search: 'Search...',
            noData: 'No data',
            organization: 'Organization',
            permission: 'Permission',
            action: 'Actions',
            close: 'Close',
            delete: `Are you sure you want to delete the share`,
            successful: `Delete Share successful.`,
        },

        deleteGroupCameraTree: {
            action: 'Actions',
            close: 'Close',
            delete: `Are you sure you want to delete group`,
            successful: `Delete Group successful.`,
        },

        pagination: {
            to: 'To'
        },

        liveStream: {
            errPlayVideo: "Video cannot be played. Please try again.",
            playVideo: "Play video",
            pauseVideo: "Pause",
            muteVideo: "Mute",
            unmuteVideo: "Unmute",
            fullScreen: "Fullscreen",
            closeFullScreen: "Exit fullscreen",
            chooseCam: "Select camera",
            preCam: "Previous Camera",
            nextCam: "Next Camera",
            capture: "Capture",
            errorLink: "Camera is off or stream is incorrect."
        },

        title: {
            error: 'Error'
        },

        policy: {
            leave: 'Leave',
            holiday: 'Holiday',
            detail: 'Policy Details'
        },

        cardCustomer: {
            magneticCard: 'Magnetic card',
            cardType: 'Card type',
            cardStatus: 'Status card',
            addCard: 'Add card',
            search: 'Search',
            allCard: 'All card',
            customer: 'Customer',
            employee: 'Employee',
            unknown: 'Unknown',
            id: 'Card code',
            startDate: 'Start date',
            back: 'Back',
            create: 'Create',
            chooseStartDate: 'Choose start date',
            using: 'Using',
            notUse: 'Do not use',
            passers: 'Passersby',
            customerType: 'Customer type'
        }
    }
}




